export var EMOJI_NAMES =
	[
		["❤", "heart"],
		["\ud7c0\udca9", "copyright"],
		["\ud7c0\udcae", "registered"],
		["\ud7c8\udc3c", "bangbang"],
		["\ud7c8\udc49", "interrobang"],
		["\ud7c8\udd22", "tm"],
		["\ud7c8\udd39", "information_source"],
		["\ud7c8\udd94", "left_right_arrow"],
		["\ud7c8\udd95", "arrow_up_down"],
		["\ud7c8\udd96", "arrow_upper_left"],
		["\ud7c8\udd97", "arrow_upper_right"],
		["\ud7c8\udd98", "arrow_lower_right"],
		["\ud7c8\udd99", "arrow_lower_left"],
		["\ud7c8\udda9", "leftwards_arrow_with_hook"],
		["\ud7c8\uddaa", "arrow_right_hook"],
		["\ud7c8\udf1a", "watch"],
		["\ud7c8\udf1b", "hourglass"],
		["\ud7c8\udf28", "keyboard"],
		["\ud7c8\udfe9", "fast_forward"],
		["\ud7c8\udfea", "rewind"],
		["\ud7c8\udfeb", "arrow_double_up"],
		["\ud7c8\udfec", "arrow_double_down"],
		["\ud7c8\udfed", "black_right_pointing_double_triangle_with_vertical_bar"],
		["\ud7c8\udfee", "black_left_pointing_double_triangle_with_vertical_bar"],
		["\ud7c8\udfef", "black_right_pointing_triangle_with_double_vertical_bar"],
		["\ud7c8\udff0", "alarm_clock"],
		["\ud7c8\udff1", "stopwatch"],
		["\ud7c8\udff2", "timer_clock"],
		["\ud7c8\udff3", "hourglass_flowing_sand"],
		["\ud7c8\udff8", "double_vertical_bar"],
		["\ud7c8\udff9", "black_square_for_stop"],
		["\ud7c8\udffa", "black_circle_for_record"],
		["\ud7c9\udcc2", "m"],
		["\ud7c9\uddaa", "black_small_square"],
		["\ud7c9\uddab", "white_small_square"],
		["\ud7c9\uddb6", "arrow_forward"],
		["\ud7c9\uddc0", "arrow_backward"],
		["\ud7c9\uddfb", "white_medium_square"],
		["\ud7c9\uddfc", "black_medium_square"],
		["\ud7c9\uddfd", "white_medium_small_square"],
		["\ud7c9\uddfe", "black_medium_small_square"],
		["\ud7c9\ude00", "sunny"],
		["\ud7c9\ude01", "cloud"],
		["\ud7c9\ude02", "umbrella"],
		["\ud7c9\ude03", "showman"],
		["\ud7c9\ude04", "comet"],
		["\ud7c9\ude0e", "phone"],
		["\ud7c9\ude11", "ballot_box_with_check"],
		["\ud7c9\ude14", "umbrella"],
		["\ud7c9\ude15", "coffee"],
		["\ud7c9\ude18", "shamrock"],
		["\ud7c9\ude1d", "point_up"],
		["\ud7c9\ude20", "skull_and_crossbones"],
		["\ud7c9\ude22", "radioactive_sign"],
		["\ud7c9\ude23", "biohazard_sign"],
		["\ud7c9\ude26", "orthodox_cross"],
		["\ud7c9\ude2a", "star_and_crescent"],
		["\ud7c9\ude2e", "peace_symbol"],
		["\ud7c9\ude2f", "yin_yang"],
		["\ud7c9\ude38", "wheel_of_dharma"],
		["\ud7c9\ude39", "white_frowning_face"],
		["\ud7c9\ude3a", "relaxed"],
		["\ud7c9\ude48", "aries"],
		["\ud7c9\ude49", "taurus"],
		["\ud7c9\ude4a", "gemini"],
		["\ud7c9\ude4b", "cancer"],
		["\ud7c9\ude4c", "leo"],
		["\ud7c9\ude4d", "virgo"],
		["\ud7c9\ude4e", "libra"],
		["\ud7c9\ude4f", "scorpius"],
		["\ud7c9\ude50", "sagittarius"],
		["\ud7c9\ude51", "capricorn"],
		["\ud7c9\ude52", "aquarius"],
		["\ud7c9\ude53", "pisces"],
		["\ud7c9\ude60", "spades"],
		["\ud7c9\ude63", "clubs"],
		["\ud7c9\ude65", "hearts"],
		["\ud7c9\ude66", "diamonds"],
		["\ud7c9\ude68", "hotsprings"],
		["\ud7c9\ude7b", "recycle"],
		["\ud7c9\ude7f", "wheelchair"],
		["\ud7c9\ude92", "hammer_and_pick"],
		["\ud7c9\ude93", "anchor"],
		["\ud7c9\ude94", "crossed_swords"],
		["\ud7c9\ude96", "scales"],
		["\ud7c9\ude97", "alembic"],
		["\ud7c9\ude99", "gear"],
		["\ud7c9\ude9b", "atom_symbol"],
		["\ud7c9\ude9c", "fleur_de_lis"],
		["\ud7c9\udea0", "warning"],
		["\ud7c9\udea1", "zap"],
		["\ud7c9\udeaa", "white_circle"],
		["\ud7c9\udeab", "black_circle"],
		["\ud7c9\udeb0", "coffin"],
		["\ud7c9\udeb1", "funeral_urn"],
		["\ud7c9\udebd", "soccer"],
		["\ud7c9\udebe", "baseball"],
		["\ud7c9\udec4", "snowman"],
		["\ud7c9\udec5", "partly_sunny"],
		["\ud7c9\udec8", "thunder_cloud_and_rain"],
		["\ud7c9\udece", "ophiuchus"],
		["\ud7c9\udecf", "pick"],
		["\ud7c9\uded1", "helmet_with_white_cross"],
		["\ud7c9\uded3", "chains"],
		["\ud7c9\uded4", "no_entry"],
		["\ud7c9\udee9", "shinto_shrine"],
		["\ud7c9\udeea", "church"],
		["\ud7c9\udef0", "mountain"],
		["\ud7c9\udef1", "umbrella_on_ground"],
		["\ud7c9\udef2", "fountain"],
		["\ud7c9\udef3", "golf"],
		["\ud7c9\udef4", "ferry"],
		["\ud7c9\udef5", "boat"],
		["\ud7c9\udef7", "skier"],
		["\ud7c9\udef8", "ice_skate"],
		["\ud7c9\udef9", "person_with_ball"],
		["\ud7c9\udefa", "tent"],
		["\ud7c9\udefd", "fuelpump"],
		["\ud7c9\udf02", "scissors"],
		["\ud7c9\udf05", "white_check_mark"],
		["\ud7c9\udf08", "airplane"],
		["\ud7c9\udf09", "email"],
		["\ud7c9\udf0a", "fist"],
		["\ud7c9\udf0b", "hand"],
		["\ud7c9\udf0c", "v"],
		["\ud7c9\udf0d", "writing_hand"],
		["\ud7c9\udf0f", "pencil2"],
		["\ud7c9\udf12", "black_nib"],
		["\ud7c9\udf14", "heavy_check_mark"],
		["\ud7c9\udf16", "heavy_multiplication_x"],
		["\ud7c9\udf1d", "latin_cross"],
		["\ud7c9\udf21", "star_of_david"],
		["\ud7c9\udf28", "sparkles"],
		["\ud7c9\udf33", "eight_spoked_asterisk"],
		["\ud7c9\udf34", "eight_pointed_black_star"],
		["\ud7c9\udf44", "snowflake"],
		["\ud7c9\udf47", "sparkle"],
		["\ud7c9\udf4c", "x"],
		["\ud7c9\udf4e", "negative_squared_cross_mark"],
		["\ud7c9\udf53", "question"],
		["\ud7c9\udf54", "grey_question"],
		["\ud7c9\udf55", "grey_exclamation"],
		["\ud7c9\udf57", "exclamation"],
		["\ud7c9\udf63", "heavy_heart_exclamation_mark_ornament"],
		["\ud7c9\udf95", "heavy_plus_sign"],
		["\ud7c9\udf96", "heavy_minus_sign"],
		["\ud7c9\udf97", "heavy_division_sign"],
		["\ud7c9\udfa1", "arrow_right"],
		["\ud7c9\udfb0", "curly_loop"],
		["\ud7c9\udfbf", "loop"],
		["\ud7ca\udd34", "arrow_heading_up"],
		["\ud7ca\udd35", "arrow_heading_down"],
		["\ud7ca\udf05", "arrow_left"],
		["\ud7ca\udf06", "arrow_up"],
		["\ud7ca\udf07", "arrow_down"],
		["\ud7ca\udf1b", "black_large_square"],
		["\ud7ca\udf1c", "white_large_square"],
		["\ud7ca\udf50", "star"],
		["\ud7ca\udf55", "o"],
		["\ud7cc\udc30", "wavy_dash"],
		["\ud7cc\udc3d", "part_alternation_mark"],
		["\ud7cc\ude97", "congratulations"],
		["\ud7cc\ude99", "secret"],
		["\ud83c\udc04", "mahjong"],
		["\ud83c\udccf", "black_joker"],
		["\ud83c\udd70", "a"],
		["\ud83c\udd71", "b"],
		["\ud83c\udd7e", "o2"],
		["\ud83c\udd7f", "parking"],
		["\ud83c\udd8e", "ab"],
		["\ud83c\udd91", "cl"],
		["\ud83c\udd92", "cool"],
		["\ud83c\udd93", "free"],
		["\ud83c\udd94", "id"],
		["\ud83c\udd95", "new"],
		["\ud83c\udd96", "ng"],
		["\ud83c\udd97", "ok"],
		["\ud83c\udd98", "sos"],
		["\ud83c\udd99", "up"],
		["\ud83c\udd9a", "vs"],
		["\ud83c\ude01", "koko"],
		["\ud83c\ude02", "sa"],
		["\ud83c\ude1a", "u7121"],
		["\ud83c\ude2f", "u6307"],
		["\ud83c\ude32", "u7981"],
		["\ud83c\ude33", "u7a7a"],
		["\ud83c\ude34", "u5408"],
		["\ud83c\ude35", "u6e80"],
		["\ud83c\ude36", "u6709"],
		["\ud83c\ude37", "u6708"],
		["\ud83c\ude38", "u7533"],
		["\ud83c\ude39", "u5272"],
		["\ud83c\ude3a", "u55b6"],
		["\ud83c\ude50", "ideograph_advantage"],
		["\ud83c\ude51", "accept"],
		["\ud83c\udf00", "cyclone"],
		["\ud83c\udf01", "foggy"],
		["\ud83c\udf02", "closed_umbrella"],
		["\ud83c\udf03", "night_with_stars"],
		["\ud83c\udf04", "sunrise_over_mountains"],
		["\ud83c\udf05", "sunrise"],
		["\ud83c\udf06", "city_sunset"],
		["\ud83c\udf07", "city_sunrise"],
		["\ud83c\udf08", "rainbow"],
		["\ud83c\udf09", "bridge_at_night"],
		["\ud83c\udf0a", "ocean"],
		["\ud83c\udf0b", "volcano"],
		["\ud83c\udf0c", "milky_way"],
		["\ud83c\udf0d", "earth_africa"],
		["\ud83c\udf0e", "earth_americas"],
		["\ud83c\udf0f", "earth_asia"],
		["\ud83c\udf10", "globe_with_meridians"],
		["\ud83c\udf11", "new_moon"],
		["\ud83c\udf12", "waxing_crescent_moon"],
		["\ud83c\udf13", "first_quarter_moon"],
		["\ud83c\udf14", "moon"],
		["\ud83c\udf15", "full_moon"],
		["\ud83c\udf16", "waning_gibbous_moon"],
		["\ud83c\udf17", "last_quarter_moon"],
		["\ud83c\udf18", "waning_crescent_moon"],
		["\ud83c\udf19", "crescent_moon"],
		["\ud83c\udf1a", "new_moon_with_face"],
		["\ud83c\udf1b", "first_quarter_moon_with_face"],
		["\ud83c\udf1c", "last_quarter_moon_with_face"],
		["\ud83c\udf1d", "full_moon_with_face"],
		["\ud83c\udf1e", "sun_with_face"],
		["\ud83c\udf1f", "star2"],
		["\ud83c\udf20", "stars"],
		["\ud83c\udf21", "thermometer"],
		["\ud83c\udf24", "mostly_sunny"],
		["\ud83c\udf25", "barely_sunny"],
		["\ud83c\udf26", "partly_sunny_rain"],
		["\ud83c\udf27", "rain_cloud"],
		["\ud83c\udf28", "snow_cloud"],
		["\ud83c\udf29", "lightening"],
		["\ud83c\udf2a", "tornado"],
		["\ud83c\udf2b", "fog"],
		["\ud83c\udf2c", "wind_blowing_face"],
		["\ud83c\udf2d", "hotdog"],
		["\ud83c\udf2e", "taco"],
		["\ud83c\udf2f", "burrito"],
		["\ud83c\udf30", "chestnut"],
		["\ud83c\udf31", "seedling"],
		["\ud83c\udf32", "evergreen_tree"],
		["\ud83c\udf33", "deciduous_tree"],
		["\ud83c\udf34", "palm_tree"],
		["\ud83c\udf35", "cactus"],
		["\ud83c\udf36", "hot_pepper"],
		["\ud83c\udf37", "tulip"],
		["\ud83c\udf38", "cherry_blossom"],
		["\ud83c\udf39", "rose"],
		["\ud83c\udf3a", "hibiscus"],
		["\ud83c\udf3b", "sunflower"],
		["\ud83c\udf3c", "blossom"],
		["\ud83c\udf3d", "corn"],
		["\ud83c\udf3e", "ear_of_rice"],
		["\ud83c\udf3f", "herb"],
		["\ud83c\udf40", "four_leaf_clover"],
		["\ud83c\udf41", "maple_leaf"],
		["\ud83c\udf42", "fallen_leaf"],
		["\ud83c\udf43", "leaves"],
		["\ud83c\udf44", "mushroom"],
		["\ud83c\udf45", "tomato"],
		["\ud83c\udf46", "eggplant"],
		["\ud83c\udf47", "grapes"],
		["\ud83c\udf48", "melon"],
		["\ud83c\udf49", "watermelon"],
		["\ud83c\udf4a", "tangerine"],
		["\ud83c\udf4b", "lemon"],
		["\ud83c\udf4c", "banana"],
		["\ud83c\udf4d", "pineapple"],
		["\ud83c\udf4e", "apple"],
		["\ud83c\udf4f", "green_apple"],
		["\ud83c\udf50", "pear"],
		["\ud83c\udf51", "peach"],
		["\ud83c\udf52", "cherries"],
		["\ud83c\udf53", "strawberry"],
		["\ud83c\udf54", "hamburger"],
		["\ud83c\udf55", "pizza"],
		["\ud83c\udf56", "meat_on_bone"],
		["\ud83c\udf57", "poultry_leg"],
		["\ud83c\udf58", "rice_cracker"],
		["\ud83c\udf59", "rice_ball"],
		["\ud83c\udf5a", "rice"],
		["\ud83c\udf5b", "curry"],
		["\ud83c\udf5c", "ramen"],
		["\ud83c\udf5d", "spaghetti"],
		["\ud83c\udf5e", "bread"],
		["\ud83c\udf5f", "fries"],
		["\ud83c\udf60", "sweet_potato"],
		["\ud83c\udf61", "dango"],
		["\ud83c\udf62", "oden"],
		["\ud83c\udf63", "sushi"],
		["\ud83c\udf64", "fried_shrimp"],
		["\ud83c\udf65", "fish_cake"],
		["\ud83c\udf66", "icecream"],
		["\ud83c\udf67", "shaved_ice"],
		["\ud83c\udf68", "ice_cream"],
		["\ud83c\udf69", "doughnut"],
		["\ud83c\udf6a", "cookie"],
		["\ud83c\udf6b", "chocolate_bar"],
		["\ud83c\udf6c", "candy"],
		["\ud83c\udf6d", "lollipop"],
		["\ud83c\udf6e", "custard"],
		["\ud83c\udf6f", "honey_pot"],
		["\ud83c\udf70", "cake"],
		["\ud83c\udf71", "bento"],
		["\ud83c\udf72", "stew"],
		["\ud83c\udf73", "egg"],
		["\ud83c\udf74", "fork_and_knife"],
		["\ud83c\udf75", "tea"],
		["\ud83c\udf76", "sake"],
		["\ud83c\udf77", "wine_glass"],
		["\ud83c\udf78", "cocktail"],
		["\ud83c\udf79", "tropical_drink"],
		["\ud83c\udf7a", "beer"],
		["\ud83c\udf7b", "beers"],
		["\ud83c\udf7c", "baby_bottle"],
		["\ud83c\udf7d", "knife_fork_plate"],
		["\ud83c\udf7e", "champagne"],
		["\ud83c\udf7f", "popcorn"],
		["\ud83c\udf80", "ribbon"],
		["\ud83c\udf81", "gift"],
		["\ud83c\udf82", "birthday"],
		["\ud83c\udf83", "jack_o_lantern"],
		["\ud83c\udf84", "christmas_tree"],
		["\ud83c\udf85", "santa"],
		["\ud83c\udf86", "fireworks"],
		["\ud83c\udf87", "sparkler"],
		["\ud83c\udf88", "balloon"],
		["\ud83c\udf89", "tada"],
		["\ud83c\udf8a", "confetti_ball"],
		["\ud83c\udf8b", "tanabata_tree"],
		["\ud83c\udf8c", "crossed_flags"],
		["\ud83c\udf8d", "bamboo"],
		["\ud83c\udf8e", "dolls"],
		["\ud83c\udf8f", "flags"],
		["\ud83c\udf90", "wind_chime"],
		["\ud83c\udf91", "rice_scene"],
		["\ud83c\udf92", "school_satchel"],
		["\ud83c\udf93", "mortar_board"],
		["\ud83c\udf96", "medal"],
		["\ud83c\udf97", "reminder_ribbon"],
		["\ud83c\udf99", "studio_microphone"],
		["\ud83c\udf9a", "level_slider"],
		["\ud83c\udf9b", "control_knobs"],
		["\ud83c\udf9e", "film_frames"],
		["\ud83c\udf9f", "admission_tickets"],
		["\ud83c\udfa0", "carousel_horse"],
		["\ud83c\udfa1", "ferris_wheel"],
		["\ud83c\udfa2", "roller_coaster"],
		["\ud83c\udfa3", "fishing_pole_and_fish"],
		["\ud83c\udfa4", "microphone"],
		["\ud83c\udfa5", "movie_camera"],
		["\ud83c\udfa6", "cinema"],
		["\ud83c\udfa7", "headphones"],
		["\ud83c\udfa8", "art"],
		["\ud83c\udfa9", "tophat"],
		["\ud83c\udfaa", "circus_tent"],
		["\ud83c\udfab", "ticket"],
		["\ud83c\udfac", "clapper"],
		["\ud83c\udfad", "performing_arts"],
		["\ud83c\udfae", "video_game"],
		["\ud83c\udfaf", "dart"],
		["\ud83c\udfb0", "slot_machine"],
		["\ud83c\udfb1", "8ball"],
		["\ud83c\udfb2", "game_die"],
		["\ud83c\udfb3", "bowling"],
		["\ud83c\udfb4", "flower_playing_cards"],
		["\ud83c\udfb5", "musical_note"],
		["\ud83c\udfb6", "notes"],
		["\ud83c\udfb7", "saxophone"],
		["\ud83c\udfb8", "guitar"],
		["\ud83c\udfb9", "musical_keyboard"],
		["\ud83c\udfba", "trumpet"],
		["\ud83c\udfbb", "violin"],
		["\ud83c\udfbc", "musical_score"],
		["\ud83c\udfbd", "running_shirt_with_sash"],
		["\ud83c\udfbe", "tennis"],
		["\ud83c\udfbf", "ski"],
		["\ud83c\udfc0", "basketball"],
		["\ud83c\udfc1", "checkered_flag"],
		["\ud83c\udfc2", "snowboarder"],
		["\ud83c\udfc3", "runner"],
		["\ud83c\udfc4", "surfer"],
		["\ud83c\udfc5", "sports_medal"],
		["\ud83c\udfc6", "trophy"],
		["\ud83c\udfc7", "horse_racing"],
		["\ud83c\udfc8", "football"],
		["\ud83c\udfc9", "rugby_football"],
		["\ud83c\udfca", "swimmer"],
		["\ud83c\udfcb", "weight_lifter"],
		["\ud83c\udfcc", "golfer"],
		["\ud83c\udfcd", "racing_motorcycle"],
		["\ud83c\udfce", "racing_car"],
		["\ud83c\udfcf", "cricket_bat_and_ball"],
		["\ud83c\udfd0", "volleyball"],
		["\ud83c\udfd1", "field_hockey_stick_and_ball"],
		["\ud83c\udfd2", "ice_hockey_stick_and_puck"],
		["\ud83c\udfd3", "table_tennis_paddle_and_ball"],
		["\ud83c\udfd4", "snow_capped_mountain"],
		["\ud83c\udfd5", "camping"],
		["\ud83c\udfd6", "beach_with_umbrella"],
		["\ud83c\udfd7", "building_construction"],
		["\ud83c\udfd8", "house_buildings"],
		["\ud83c\udfd9", "cityscape"],
		["\ud83c\udfda", "derelict_house_building"],
		["\ud83c\udfdb", "classical_building"],
		["\ud83c\udfdc", "desert"],
		["\ud83c\udfdd", "desert_island"],
		["\ud83c\udfde", "national_park"],
		["\ud83c\udfdf", "stadium"],
		["\ud83c\udfe0", "house"],
		["\ud83c\udfe1", "house_with_garden"],
		["\ud83c\udfe2", "office"],
		["\ud83c\udfe3", "post_office"],
		["\ud83c\udfe4", "european_post_office"],
		["\ud83c\udfe5", "hospital"],
		["\ud83c\udfe6", "bank"],
		["\ud83c\udfe7", "atm"],
		["\ud83c\udfe8", "hotel"],
		["\ud83c\udfe9", "love_hotel"],
		["\ud83c\udfea", "convenience_store"],
		["\ud83c\udfeb", "school"],
		["\ud83c\udfec", "department_store"],
		["\ud83c\udfed", "factory"],
		["\ud83c\udfee", "izakaya_lantern"],
		["\ud83c\udfef", "japanese_castle"],
		["\ud83c\udff0", "european_castle"],
		["\ud83c\udff3", "waving_white_flag"],
		["\ud83c\udff4", "waving_black_flag"],
		["\ud83c\udff5", "rosette"],
		["\ud83c\udff7", "label"],
		["\ud83c\udff8", "badminton_racquet_and_shuttlecock"],
		["\ud83c\udff9", "bow_and_arrow"],
		["\ud83c\udffa", "amphora"],
		["\ud83c\udffb", "skin-tone-2"],
		["\ud83c\udffc", "skin-tone-3"],
		["\ud83c\udffd", "skin-tone-4"],
		["\ud83c\udffe", "skin-tone-5"],
		["\ud83c\udfff", "skin-tone-6"],
		["\ud83d\udc00", "rat"],
		["\ud83d\udc01", "mouse2"],
		["\ud83d\udc02", "ox"],
		["\ud83d\udc03", "water_buffalo"],
		["\ud83d\udc04", "cow2"],
		["\ud83d\udc05", "tiger2"],
		["\ud83d\udc06", "leopard"],
		["\ud83d\udc07", "rabbit2"],
		["\ud83d\udc08", "cat2"],
		["\ud83d\udc09", "dragon"],
		["\ud83d\udc0a", "crocodile"],
		["\ud83d\udc0b", "whale2"],
		["\ud83d\udc0c", "snail"],
		["\ud83d\udc0d", "snake"],
		["\ud83d\udc0e", "racehorse"],
		["\ud83d\udc0f", "ram"],
		["\ud83d\udc10", "goat"],
		["\ud83d\udc11", "sheep"],
		["\ud83d\udc12", "monkey"],
		["\ud83d\udc13", "rooster"],
		["\ud83d\udc14", "chicken"],
		["\ud83d\udc15", "dog2"],
		["\ud83d\udc16", "pig2"],
		["\ud83d\udc17", "boar"],
		["\ud83d\udc18", "elephant"],
		["\ud83d\udc19", "octopus"],
		["\ud83d\udc1a", "shell"],
		["\ud83d\udc1b", "bug"],
		["\ud83d\udc1c", "ant"],
		["\ud83d\udc1d", "bee"],
		["\ud83d\udc1e", "beetle"],
		["\ud83d\udc1f", "fish"],
		["\ud83d\udc20", "tropical_fish"],
		["\ud83d\udc21", "blowfish"],
		["\ud83d\udc22", "turtle"],
		["\ud83d\udc23", "hatching_chick"],
		["\ud83d\udc24", "baby_chick"],
		["\ud83d\udc25", "hatched_chick"],
		["\ud83d\udc26", "bird"],
		["\ud83d\udc27", "penguin"],
		["\ud83d\udc28", "koala"],
		["\ud83d\udc29", "poodle"],
		["\ud83d\udc2a", "dromedary_camel"],
		["\ud83d\udc2b", "camel"],
		["\ud83d\udc2c", "dolphin"],
		["\ud83d\udc2d", "mouse"],
		["\ud83d\udc2e", "cow"],
		["\ud83d\udc2f", "tiger"],
		["\ud83d\udc30", "rabbit"],
		["\ud83d\udc31", "cat"],
		["\ud83d\udc32", "dragon_face"],
		["\ud83d\udc33", "whale"],
		["\ud83d\udc34", "horse"],
		["\ud83d\udc35", "monkey_face"],
		["\ud83d\udc36", "dog"],
		["\ud83d\udc37", "pig"],
		["\ud83d\udc38", "frog"],
		["\ud83d\udc39", "hamster"],
		["\ud83d\udc3a", "wolf"],
		["\ud83d\udc3b", "bear"],
		["\ud83d\udc3c", "panda_face"],
		["\ud83d\udc3d", "pig_nose"],
		["\ud83d\udc3e", "feet"],
		["\ud83d\udc3f", "chipmunk"],
		["\ud83d\udc40", "eyes"],
		["\ud83d\udc41", "eye"],
		["\ud83d\udc42", "ear"],
		["\ud83d\udc43", "nose"],
		["\ud83d\udc44", "lips"],
		["\ud83d\udc45", "tongue"],
		["\ud83d\udc46", "point_up_2"],
		["\ud83d\udc47", "point_down"],
		["\ud83d\udc48", "point_left"],
		["\ud83d\udc49", "point_right"],
		["\ud83d\udc4a", "facepunch"],
		["\ud83d\udc4b", "wave"],
		["\ud83d\udc4c", "ok_hand"],
		["\ud83d\udc4d", "+1"],
		["\ud83d\udc4e", "-1"],
		["\ud83d\udc4f", "clap"],
		["\ud83d\udc50", "open_hands"],
		["\ud83d\udc51", "crown"],
		["\ud83d\udc52", "womans_hat"],
		["\ud83d\udc53", "eyeglasses"],
		["\ud83d\udc54", "necktie"],
		["\ud83d\udc55", "shirt"],
		["\ud83d\udc56", "jeans"],
		["\ud83d\udc57", "dress"],
		["\ud83d\udc58", "kimono"],
		["\ud83d\udc59", "bikini"],
		["\ud83d\udc5a", "womans_clothes"],
		["\ud83d\udc5b", "purse"],
		["\ud83d\udc5c", "handbag"],
		["\ud83d\udc5d", "pouch"],
		["\ud83d\udc5e", "mans_shoe"],
		["\ud83d\udc5f", "athletic_shoe"],
		["\ud83d\udc60", "high_heel"],
		["\ud83d\udc61", "sandal"],
		["\ud83d\udc62", "boot"],
		["\ud83d\udc63", "footprints"],
		["\ud83d\udc64", "bust_in_silhouette"],
		["\ud83d\udc65", "busts_in_silhouette"],
		["\ud83d\udc66", "boy"],
		["\ud83d\udc67", "girl"],
		["\ud83d\udc68", "man"],
		["\ud83d\udc69", "woman"],
		["\ud83d\udc6a", "family"],
		["\ud83d\udc6b", "couple"],
		["\ud83d\udc6c", "two_men_holding_hands"],
		["\ud83d\udc6d", "two_women_holding_hands"],
		["\ud83d\udc6e", "cop"],
		["\ud83d\udc6f", "dancers"],
		["\ud83d\udc70", "bride_with_veil"],
		["\ud83d\udc71", "person_with_blond_hair"],
		["\ud83d\udc72", "man_with_gua_pi_mao"],
		["\ud83d\udc73", "man_with_turban"],
		["\ud83d\udc74", "older_man"],
		["\ud83d\udc75", "older_woman"],
		["\ud83d\udc76", "baby"],
		["\ud83d\udc77", "construction_worker"],
		["\ud83d\udc78", "princess"],
		["\ud83d\udc79", "japanese_ogre"],
		["\ud83d\udc7a", "japanese_goblin"],
		["\ud83d\udc7b", "ghost"],
		["\ud83d\udc7c", "angel"],
		["\ud83d\udc7d", "alien"],
		["\ud83d\udc7e", "space_invader"],
		["\ud83d\udc7f", "imp"],
		["\ud83d\udc80", "skull"],
		["\ud83d\udc81", "information_desk_person"],
		["\ud83d\udc82", "guardsman"],
		["\ud83d\udc83", "dancer"],
		["\ud83d\udc84", "lipstick"],
		["\ud83d\udc85", "nail_care"],
		["\ud83d\udc86", "massage"],
		["\ud83d\udc87", "haircut"],
		["\ud83d\udc88", "barber"],
		["\ud83d\udc89", "syringe"],
		["\ud83d\udc8a", "pill"],
		["\ud83d\udc8b", "kiss"],
		["\ud83d\udc8c", "love_letter"],
		["\ud83d\udc8d", "ring"],
		["\ud83d\udc8e", "gem"],
		["\ud83d\udc8f", "couplekiss"],
		["\ud83d\udc90", "bouquet"],
		["\ud83d\udc91", "couple_with_heart"],
		["\ud83d\udc92", "wedding"],
		["\ud83d\udc93", "heartbeat"],
		["\ud83d\udc94", "broken_heart"],
		["\ud83d\udc95", "two_hearts"],
		["\ud83d\udc96", "sparkling_heart"],
		["\ud83d\udc97", "heartpulse"],
		["\ud83d\udc98", "cupid"],
		["\ud83d\udc99", "blue_heart"],
		["\ud83d\udc9a", "green_heart"],
		["\ud83d\udc9b", "yellow_heart"],
		["\ud83d\udc9c", "purple_heart"],
		["\ud83d\udc9d", "gift_heart"],
		["\ud83d\udc9e", "revolving_hearts"],
		["\ud83d\udc9f", "heart_decoration"],
		["\ud83d\udca0", "diamond_shape_with_a_dot_inside"],
		["\ud83d\udca1", "bulb"],
		["\ud83d\udca2", "anger"],
		["\ud83d\udca3", "bomb"],
		["\ud83d\udca4", "zzz"],
		["\ud83d\udca5", "boom"],
		["\ud83d\udca6", "sweat_drops"],
		["\ud83d\udca7", "droplet"],
		["\ud83d\udca8", "dash"],
		["\ud83d\udca9", "hankey"],
		["\ud83d\udcaa", "muscle"],
		["\ud83d\udcab", "dizzy"],
		["\ud83d\udcac", "speech_balloon"],
		["\ud83d\udcad", "thought_balloon"],
		["\ud83d\udcae", "white_flower"],
		["\ud83d\udcaf", "100"],
		["\ud83d\udcb0", "moneybag"],
		["\ud83d\udcb1", "currency_exchange"],
		["\ud83d\udcb2", "heavy_dollar_sign"],
		["\ud83d\udcb3", "credit_card"],
		["\ud83d\udcb4", "yen"],
		["\ud83d\udcb5", "dollar"],
		["\ud83d\udcb6", "euro"],
		["\ud83d\udcb7", "pound"],
		["\ud83d\udcb8", "money_with_wings"],
		["\ud83d\udcb9", "chart"],
		["\ud83d\udcba", "seat"],
		["\ud83d\udcbb", "computer"],
		["\ud83d\udcbc", "briefcase"],
		["\ud83d\udcbd", "minidisc"],
		["\ud83d\udcbe", "floppy_disk"],
		["\ud83d\udcbf", "cd"],
		["\ud83d\udcc0", "dvd"],
		["\ud83d\udcc1", "file_folder"],
		["\ud83d\udcc2", "open_file_folder"],
		["\ud83d\udcc3", "page_with_curl"],
		["\ud83d\udcc4", "page_facing_up"],
		["\ud83d\udcc5", "date"],
		["\ud83d\udcc6", "calendar"],
		["\ud83d\udcc7", "card_index"],
		["\ud83d\udcc8", "chart_with_upwards_trend"],
		["\ud83d\udcc9", "chart_with_downwards_trend"],
		["\ud83d\udcca", "bar_chart"],
		["\ud83d\udccb", "clipboard"],
		["\ud83d\udccc", "pushpin"],
		["\ud83d\udccd", "round_pushpin"],
		["\ud83d\udcce", "paperclip"],
		["\ud83d\udccf", "straight_ruler"],
		["\ud83d\udcd0", "triangular_ruler"],
		["\ud83d\udcd1", "bookmark_tabs"],
		["\ud83d\udcd2", "ledger"],
		["\ud83d\udcd3", "notebook"],
		["\ud83d\udcd4", "notebook_with_decorative_cover"],
		["\ud83d\udcd5", "closed_book"],
		["\ud83d\udcd6", "book"],
		["\ud83d\udcd7", "green_book"],
		["\ud83d\udcd8", "blue_book"],
		["\ud83d\udcd9", "orange_book"],
		["\ud83d\udcda", "books"],
		["\ud83d\udcdb", "name_badge"],
		["\ud83d\udcdc", "scroll"],
		["\ud83d\udcdd", "memo"],
		["\ud83d\udcde", "telephone_receiver"],
		["\ud83d\udcdf", "pager"],
		["\ud83d\udce0", "fax"],
		["\ud83d\udce1", "satellite"],
		["\ud83d\udce2", "loudspeaker"],
		["\ud83d\udce3", "mega"],
		["\ud83d\udce4", "outbox_tray"],
		["\ud83d\udce5", "inbox_tray"],
		["\ud83d\udce6", "package"],
		["\ud83d\udce7", "e-mail"],
		["\ud83d\udce8", "incoming_envelope"],
		["\ud83d\udce9", "envelope_with_arrow"],
		["\ud83d\udcea", "mailbox_closed"],
		["\ud83d\udceb", "mailbox"],
		["\ud83d\udcec", "mailbox_with_mail"],
		["\ud83d\udced", "mailbox_with_no_mail"],
		["\ud83d\udcee", "postbox"],
		["\ud83d\udcef", "postal_horn"],
		["\ud83d\udcf0", "newspaper"],
		["\ud83d\udcf1", "iphone"],
		["\ud83d\udcf2", "calling"],
		["\ud83d\udcf3", "vibration_mode"],
		["\ud83d\udcf4", "mobile_phone_off"],
		["\ud83d\udcf5", "no_mobile_phones"],
		["\ud83d\udcf6", "signal_strength"],
		["\ud83d\udcf7", "camera"],
		["\ud83d\udcf8", "camera_with_flash"],
		["\ud83d\udcf9", "video_camera"],
		["\ud83d\udcfa", "tv"],
		["\ud83d\udcfb", "radio"],
		["\ud83d\udcfc", "vhs"],
		["\ud83d\udcfd", "film_projector"],
		["\ud83d\udcff", "prayer_beads"],
		["\ud83d\udd00", "twisted_rightwards_arrows"],
		["\ud83d\udd01", "repeat"],
		["\ud83d\udd02", "repeat_one"],
		["\ud83d\udd03", "arrows_clockwise"],
		["\ud83d\udd04", "arrows_counterclockwise"],
		["\ud83d\udd05", "low_brightness"],
		["\ud83d\udd06", "high_brightness"],
		["\ud83d\udd07", "mute"],
		["\ud83d\udd08", "speaker"],
		["\ud83d\udd09", "sound"],
		["\ud83d\udd0a", "loud_sound"],
		["\ud83d\udd0b", "battery"],
		["\ud83d\udd0c", "electric_plug"],
		["\ud83d\udd0d", "mag"],
		["\ud83d\udd0e", "mag_right"],
		["\ud83d\udd0f", "lock_with_ink_pen"],
		["\ud83d\udd10", "closed_lock_with_key"],
		["\ud83d\udd11", "key"],
		["\ud83d\udd12", "lock"],
		["\ud83d\udd13", "unlock"],
		["\ud83d\udd14", "bell"],
		["\ud83d\udd15", "no_bell"],
		["\ud83d\udd16", "bookmark"],
		["\ud83d\udd17", "link"],
		["\ud83d\udd18", "radio_button"],
		["\ud83d\udd19", "back"],
		["\ud83d\udd1a", "end"],
		["\ud83d\udd1b", "on"],
		["\ud83d\udd1c", "soon"],
		["\ud83d\udd1d", "top"],
		["\ud83d\udd1e", "underage"],
		["\ud83d\udd1f", "keycap_ten"],
		["\ud83d\udd20", "capital_abcd"],
		["\ud83d\udd21", "abcd"],
		["\ud83d\udd22", "1234"],
		["\ud83d\udd23", "symbols"],
		["\ud83d\udd24", "abc"],
		["\ud83d\udd25", "fire"],
		["\ud83d\udd26", "flashlight"],
		["\ud83d\udd27", "wrench"],
		["\ud83d\udd28", "hammer"],
		["\ud83d\udd29", "nut_and_bolt"],
		["\ud83d\udd2a", "hocho"],
		["\ud83d\udd2b", "gun"],
		["\ud83d\udd2c", "microscope"],
		["\ud83d\udd2d", "telescope"],
		["\ud83d\udd2e", "crystal_ball"],
		["\ud83d\udd2f", "six_pointed_star"],
		["\ud83d\udd30", "beginner"],
		["\ud83d\udd31", "trident"],
		["\ud83d\udd32", "black_square_button"],
		["\ud83d\udd33", "white_square_button"],
		["\ud83d\udd34", "red_circle"],
		["\ud83d\udd35", "large_blue_circle"],
		["\ud83d\udd36", "large_orange_diamond"],
		["\ud83d\udd37", "large_blue_diamond"],
		["\ud83d\udd38", "small_orange_diamond"],
		["\ud83d\udd39", "small_blue_diamond"],
		["\ud83d\udd3a", "small_red_triangle"],
		["\ud83d\udd3b", "small_red_triangle_down"],
		["\ud83d\udd3c", "arrow_up_small"],
		["\ud83d\udd3d", "arrow_down_small"],
		["\ud83d\udd49", "om_symbol"],
		["\ud83d\udd4a", "dove_of_peace"],
		["\ud83d\udd4b", "kaaba"],
		["\ud83d\udd4c", "mosque"],
		["\ud83d\udd4d", "synagogue"],
		["\ud83d\udd4e", "menorah_with_nine_branches"],
		["\ud83d\udd50", "clock1"],
		["\ud83d\udd51", "clock2"],
		["\ud83d\udd52", "clock3"],
		["\ud83d\udd53", "clock4"],
		["\ud83d\udd54", "clock5"],
		["\ud83d\udd55", "clock6"],
		["\ud83d\udd56", "clock7"],
		["\ud83d\udd57", "clock8"],
		["\ud83d\udd58", "clock9"],
		["\ud83d\udd59", "clock10"],
		["\ud83d\udd5a", "clock11"],
		["\ud83d\udd5b", "clock12"],
		["\ud83d\udd5c", "clock130"],
		["\ud83d\udd5d", "clock230"],
		["\ud83d\udd5e", "clock330"],
		["\ud83d\udd5f", "clock430"],
		["\ud83d\udd60", "clock530"],
		["\ud83d\udd61", "clock630"],
		["\ud83d\udd62", "clock730"],
		["\ud83d\udd63", "clock830"],
		["\ud83d\udd64", "clock930"],
		["\ud83d\udd65", "clock1030"],
		["\ud83d\udd66", "clock1130"],
		["\ud83d\udd67", "clock1230"],
		["\ud83d\udd6f", "candle"],
		["\ud83d\udd70", "mantelpiece_clock"],
		["\ud83d\udd73", "hole"],
		["\ud83d\udd74", "man_in_business_suit_levitating"],
		["\ud83d\udd75", "sleuth_or_spy"],
		["\ud83d\udd76", "dark_sunglasses"],
		["\ud83d\udd77", "spider"],
		["\ud83d\udd78", "spider_web"],
		["\ud83d\udd79", "joystick"],
		["\ud83d\udd87", "linked_paperclips"],
		["\ud83d\udd8a", "lower_left_ballpoint_pen"],
		["\ud83d\udd8b", "lower_left_fountain_pen"],
		["\ud83d\udd8c", "lower_left_paintbrush"],
		["\ud83d\udd8d", "lower_left_crayon"],
		["\ud83d\udd90", "raised_hand_with_fingers_splayed"],
		["\ud83d\udd95", "middle_finger"],
		["\ud83d\udd96", "spock-hand"],
		["\ud83d\udda5", "desktop_computer"],
		["\ud83d\udda8", "printer"],
		["\ud83d\uddb1", "three_button_mouse"],
		["\ud83d\uddb2", "trackball"],
		["\ud83d\uddbc", "frame_with_picture"],
		["\ud83d\uddc2", "card_index_dividers"],
		["\ud83d\uddc3", "card_file_box"],
		["\ud83d\uddc4", "file_cabinet"],
		["\ud83d\uddd1", "wastebasket"],
		["\ud83d\uddd2", "spiral_note_pad"],
		["\ud83d\uddd3", "spiral_calendar_pad"],
		["\ud83d\udddc", "compression"],
		["\ud83d\udddd", "old_key"],
		["\ud83d\uddde", "rolled_up_newspaper"],
		["\ud83d\udde1", "dagger_knife"],
		["\ud83d\udde3", "speaking_head_in_silhouette"],
		["\ud83d\udde8", "left_speech_bubble"],
		["\ud83d\uddef", "right_anger_bubble"],
		["\ud83d\uddf3", "ballot_box_with_ballot"],
		["\ud83d\uddfa", "world_map"],
		["\ud83d\uddfb", "mount_fuji"],
		["\ud83d\uddfc", "tokyo_tower"],
		["\ud83d\uddfd", "statue_of_liberty"],
		["\ud83d\uddfe", "japan"],
		["\ud83d\uddff", "moyai"],
		["\ud83d\ude00", "grinning"],
		["\ud83d\ude01", "grin"],
		["\ud83d\ude02", "joy"],
		["\ud83d\ude03", "smiley"],
		["\ud83d\ude04", "smile"],
		["\ud83d\ude05", "sweat_smile"],
		["\ud83d\ude06", "laughing"],
		["\ud83d\ude07", "innocent"],
		["\ud83d\ude08", "smiling_imp"],
		["\ud83d\ude09", "wink"],
		["\ud83d\ude0a", "blush"],
		["\ud83d\ude0b", "yum"],
		["\ud83d\ude0c", "relieved"],
		["\ud83d\ude0d", "heart_eyes"],
		["\ud83d\ude0e", "sunglasses"],
		["\ud83d\ude0f", "smirk"],
		["\ud83d\ude10", "neutral_face"],
		["\ud83d\ude11", "expressionless"],
		["\ud83d\ude12", "unamused"],
		["\ud83d\ude13", "sweat"],
		["\ud83d\ude14", "pensive"],
		["\ud83d\ude15", "confused"],
		["\ud83d\ude16", "confounded"],
		["\ud83d\ude17", "kissing"],
		["\ud83d\ude18", "kissing_heart"],
		["\ud83d\ude19", "kissing_smiling_eyes"],
		["\ud83d\ude1a", "kissing_closed_eyes"],
		["\ud83d\ude1b", "stuck_out_tongue"],
		["\ud83d\ude1c", "stuck_out_tongue_winking_eye"],
		["\ud83d\ude1d", "stuck_out_tongue_closed_eyes"],
		["\ud83d\ude1e", "disappointed"],
		["\ud83d\ude1f", "worried"],
		["\ud83d\ude20", "angry"],
		["\ud83d\ude21", "rage"],
		["\ud83d\ude22", "cry"],
		["\ud83d\ude23", "persevere"],
		["\ud83d\ude24", "triumph"],
		["\ud83d\ude25", "disappointed_relieved"],
		["\ud83d\ude26", "frowning"],
		["\ud83d\ude27", "anguished"],
		["\ud83d\ude28", "fearful"],
		["\ud83d\ude29", "weary"],
		["\ud83d\ude2a", "sleepy"],
		["\ud83d\ude2b", "tired_face"],
		["\ud83d\ude2c", "grimacing"],
		["\ud83d\ude2d", "sob"],
		["\ud83d\ude2e", "open_mouth"],
		["\ud83d\ude2f", "hushed"],
		["\ud83d\ude30", "cold_sweat"],
		["\ud83d\ude31", "scream"],
		["\ud83d\ude32", "astonished"],
		["\ud83d\ude33", "flushed"],
		["\ud83d\ude34", "sleeping"],
		["\ud83d\ude35", "dizzy_face"],
		["\ud83d\ude36", "no_mouth"],
		["\ud83d\ude37", "mask"],
		["\ud83d\ude38", "smile_cat"],
		["\ud83d\ude39", "joy_cat"],
		["\ud83d\ude3a", "smiley_cat"],
		["\ud83d\ude3b", "heart_eyes_cat"],
		["\ud83d\ude3c", "smirk_cat"],
		["\ud83d\ude3d", "kissing_cat"],
		["\ud83d\ude3e", "pouting_cat"],
		["\ud83d\ude3f", "crying_cat_face"],
		["\ud83d\ude40", "scream_cat"],
		["\ud83d\ude41", "slightly_frowning_face"],
		["\ud83d\ude42", "slightly_smiling_face"],
		["\ud83d\ude43", "upside_down_face"],
		["\ud83d\ude44", "face_with_rolling_eyes"],
		["\ud83d\ude45", "no_good"],
		["\ud83d\ude46", "ok_woman"],
		["\ud83d\ude47", "bow"],
		["\ud83d\ude48", "see_no_evil"],
		["\ud83d\ude49", "hear_no_evil"],
		["\ud83d\ude4a", "speak_no_evil"],
		["\ud83d\ude4b", "raising_hand"],
		["\ud83d\ude4c", "raised_hands"],
		["\ud83d\ude4d", "person_frowning"],
		["\ud83d\ude4e", "person_with_pouting_face"],
		["\ud83d\ude4f", "pray"],
		["\ud83d\ude80", "rocket"],
		["\ud83d\ude81", "helicopter"],
		["\ud83d\ude82", "steam_locomotive"],
		["\ud83d\ude83", "railway_car"],
		["\ud83d\ude84", "bullettrain_side"],
		["\ud83d\ude85", "bullettrain_front"],
		["\ud83d\ude86", "train2"],
		["\ud83d\ude87", "metro"],
		["\ud83d\ude88", "light_rail"],
		["\ud83d\ude89", "station"],
		["\ud83d\ude8a", "tram"],
		["\ud83d\ude8b", "train"],
		["\ud83d\ude8c", "bus"],
		["\ud83d\ude8d", "oncoming_bus"],
		["\ud83d\ude8e", "trolleybus"],
		["\ud83d\ude8f", "busstop"],
		["\ud83d\ude90", "minibus"],
		["\ud83d\ude91", "ambulance"],
		["\ud83d\ude92", "fire_engine"],
		["\ud83d\ude93", "police_car"],
		["\ud83d\ude94", "oncoming_police_car"],
		["\ud83d\ude95", "taxi"],
		["\ud83d\ude96", "oncoming_taxi"],
		["\ud83d\ude97", "car"],
		["\ud83d\ude98", "oncoming_automobile"],
		["\ud83d\ude99", "blue_car"],
		["\ud83d\ude9a", "truck"],
		["\ud83d\ude9b", "articulated_lorry"],
		["\ud83d\ude9c", "tractor"],
		["\ud83d\ude9d", "monorail"],
		["\ud83d\ude9e", "mountain_railway"],
		["\ud83d\ude9f", "suspension_railway"],
		["\ud83d\udea0", "mountain_cableway"],
		["\ud83d\udea1", "aerial_tramway"],
		["\ud83d\udea2", "ship"],
		["\ud83d\udea3", "rowboat"],
		["\ud83d\udea4", "speedboat"],
		["\ud83d\udea5", "traffic_light"],
		["\ud83d\udea6", "vertical_traffic_light"],
		["\ud83d\udea7", "construction"],
		["\ud83d\udea8", "rotating_light"],
		["\ud83d\udea9", "triangular_flag_on_post"],
		["\ud83d\udeaa", "door"],
		["\ud83d\udeab", "no_entry_sign"],
		["\ud83d\udeac", "smoking"],
		["\ud83d\udead", "no_smoking"],
		["\ud83d\udeae", "put_litter_in_its_place"],
		["\ud83d\udeaf", "do_not_litter"],
		["\ud83d\udeb0", "potable_water"],
		["\ud83d\udeb1", "non-potable_water"],
		["\ud83d\udeb2", "bike"],
		["\ud83d\udeb3", "no_bicycles"],
		["\ud83d\udeb4", "bicyclist"],
		["\ud83d\udeb5", "mountain_bicyclist"],
		["\ud83d\udeb6", "walking"],
		["\ud83d\udeb7", "no_pedestrians"],
		["\ud83d\udeb8", "children_crossing"],
		["\ud83d\udeb9", "mens"],
		["\ud83d\udeba", "womens"],
		["\ud83d\udebb", "restroom"],
		["\ud83d\udebc", "baby_symbol"],
		["\ud83d\udebd", "toilet"],
		["\ud83d\udebe", "wc"],
		["\ud83d\udebf", "shower"],
		["\ud83d\udec0", "bath"],
		["\ud83d\udec1", "bathtub"],
		["\ud83d\udec2", "passport_control"],
		["\ud83d\udec3", "customs"],
		["\ud83d\udec4", "baggage_claim"],
		["\ud83d\udec5", "left_luggage"],
		["\ud83d\udecb", "couch_and_lamp"],
		["\ud83d\udecc", "sleeping_accommodation"],
		["\ud83d\udecd", "shopping_bags"],
		["\ud83d\udece", "bellhop_bell"],
		["\ud83d\udecf", "bed"],
		["\ud83d\uded0", "place_of_worship"],
		["\ud83d\udee0", "hammer_and_wrench"],
		["\ud83d\udee1", "shield"],
		["\ud83d\udee2", "oil_drum"],
		["\ud83d\udee3", "motorway"],
		["\ud83d\udee4", "railway_track"],
		["\ud83d\udee5", "motor_boat"],
		["\ud83d\udee9", "small_airplane"],
		["\ud83d\udeeb", "airplane_departure"],
		["\ud83d\udeec", "airplane_arriving"],
		["\ud83d\udef0", "satellite"],
		["\ud83d\udef3", "passenger_ship"],
		["\ud83e\udd10", "zipper_mouth_face"],
		["\ud83e\udd11", "money_mouth_face"],
		["\ud83e\udd12", "face_with_thermometer"],
		["\ud83e\udd13", "nerd_face"],
		["\ud83e\udd14", "thinking_face"],
		["\ud83e\udd15", "face_with_head_bandage"],
		["\ud83e\udd16", "robot_face"],
		["\ud83e\udd17", "hugging_face"],
		["\ud83e\udd18", "the_horns"],
		["\ud83e\udd80", "crab"],
		["\ud83e\udd81", "lion_face"],
		["\ud83e\udd82", "scorpian"],
		["\ud83e\udd83", "turkey"],
		["\ud83e\udd84", "unicorn_face"],
		["\ud83e\uddc0", "cheese_wedge"],
		["\ud7c8\udce3", "hash"],
		["\ud7c8\udce3", "keycap_star"],
		["\ud7c8\udce3", "zero"],
		["\ud7c8\udce3", "one"],
		["\ud7c8\udce3", "two"],
		["\ud7c8\udce3", "three"],
		["\ud7c8\udce3", "four"],
		["\ud7c8\udce3", "five"],
		["\ud7c8\udce3", "six"],
		["\ud7c8\udce3", "seven"],
		["\ud7c8\udce3", "eight"],
		["\ud7c8\udce3", "nine"],
		["\ud83c\udde8", "flag-ac"],
		["\ud83c\udde9", "flag-ad"],
		["\ud83c\uddea", "flag-ae"],
		["\ud83c\uddeb", "flag-af"],
		["\ud83c\uddec", "flag-ag"],
		["\ud83c\uddee", "flag-ai"],
		["\ud83c\uddf1", "flag-al"],
		["\ud83c\uddf2", "flag-am"],
		["\ud83c\uddf4", "flag-ao"],
		["\ud83c\uddf6", "flag-aq"],
		["\ud83c\uddf7", "flag-ar"],
		["\ud83c\uddf8", "flag-as"],
		["\ud83c\uddf9", "flag-at"],
		["\ud83c\uddfa", "flag-au"],
		["\ud83c\uddfc", "flag-aw"],
		["\ud83c\uddfd", "flag-ax"],
		["\ud83c\uddff", "flag-az"],
		["\ud83c\udde6", "flag-ba"],
		["\ud83c\udde7", "flag-bb"],
		["\ud83c\udde9", "flag-bd"],
		["\ud83c\uddea", "flag-be"],
		["\ud83c\uddeb", "flag-bf"],
		["\ud83c\uddec", "flag-bg"],
		["\ud83c\udded", "flag-bh"],
		["\ud83c\uddee", "flag-bi"],
		["\ud83c\uddef", "flag-bj"],
		["\ud83c\uddf1", "flag-bl"],
		["\ud83c\uddf2", "flag-bm"],
		["\ud83c\uddf3", "flag-bn"],
		["\ud83c\uddf4", "flag-bo"],
		["\ud83c\uddf6", "flag-bq"],
		["\ud83c\uddf7", "flag-br"],
		["\ud83c\uddf8", "flag-bs"],
		["\ud83c\uddf9", "flag-bt"],
		["\ud83c\uddfb", "flag-bv"],
		["\ud83c\uddfc", "flag-bw"],
		["\ud83c\uddfe", "flag-by"],
		["\ud83c\uddff", "flag-bz"],
		["\ud83c\udde6", "flag-ca"],
		["\ud83c\udde8", "flag-cc"],
		["\ud83c\udde9", "flag-cd"],
		["\ud83c\uddeb", "flag-cf"],
		["\ud83c\uddec", "flag-cg"],
		["\ud83c\udded", "flag-ch"],
		["\ud83c\uddee", "flag-ci"],
		["\ud83c\uddf0", "flag-ck"],
		["\ud83c\uddf1", "flag-cl"],
		["\ud83c\uddf2", "flag-cm"],
		["\ud83c\uddf3", "flag-cn"],
		["\ud83c\uddf4", "flag-co"],
		["\ud83c\uddf5", "flag-cp"],
		["\ud83c\uddf7", "flag-cr"],
		["\ud83c\uddfa", "flag-cu"],
		["\ud83c\uddfb", "flag-cv"],
		["\ud83c\uddfc", "flag-cw"],
		["\ud83c\uddfd", "flag-cx"],
		["\ud83c\uddfe", "flag-cy"],
		["\ud83c\uddff", "flag-cz"],
		["\ud83c\uddea", "flag-de"],
		["\ud83c\uddec", "flag-dg"],
		["\ud83c\uddef", "flag-dj"],
		["\ud83c\uddf0", "flag-dk"],
		["\ud83c\uddf2", "flag-dm"],
		["\ud83c\uddf4", "flag-do"],
		["\ud83c\uddff", "flag-dz"],
		["\ud83c\udde6", "flag-ea"],
		["\ud83c\udde8", "flag-ec"],
		["\ud83c\uddea", "flag-ee"],
		["\ud83c\uddec", "flag-eg"],
		["\ud83c\udded", "flag-eh"],
		["\ud83c\uddf7", "flag-er"],
		["\ud83c\uddf8", "flag-es"],
		["\ud83c\uddf9", "flag-et"],
		["\ud83c\uddfa", "flag-eu"],
		["\ud83c\uddee", "flag-fi"],
		["\ud83c\uddef", "flag-fj"],
		["\ud83c\uddf0", "flag-fk"],
		["\ud83c\uddf2", "flag-fm"],
		["\ud83c\uddf4", "flag-fo"],
		["\ud83c\uddf7", "flag-fr"],
		["\ud83c\udde6", "flag-ga"],
		["\ud83c\udde7", "flag-gb"],
		["\ud83c\udde9", "flag-gd"],
		["\ud83c\uddea", "flag-ge"],
		["\ud83c\uddeb", "flag-gf"],
		["\ud83c\uddec", "flag-gg"],
		["\ud83c\udded", "flag-gh"],
		["\ud83c\uddee", "flag-gi"],
		["\ud83c\uddf1", "flag-gl"],
		["\ud83c\uddf2", "flag-gm"],
		["\ud83c\uddf3", "flag-gn"],
		["\ud83c\uddf5", "flag-gp"],
		["\ud83c\uddf6", "flag-gq"],
		["\ud83c\uddf7", "flag-gr"],
		["\ud83c\uddf8", "flag-gs"],
		["\ud83c\uddf9", "flag-gt"],
		["\ud83c\uddfa", "flag-gu"],
		["\ud83c\uddfc", "flag-gw"],
		["\ud83c\uddfe", "flag-gy"],
		["\ud83c\uddf0", "flag-hk"],
		["\ud83c\uddf2", "flag-hm"],
		["\ud83c\uddf3", "flag-hn"],
		["\ud83c\uddf7", "flag-hr"],
		["\ud83c\uddf9", "flag-ht"],
		["\ud83c\uddfa", "flag-hu"],
		["\ud83c\udde8", "flag-ic"],
		["\ud83c\udde9", "flag-id"],
		["\ud83c\uddea", "flag-ie"],
		["\ud83c\uddf1", "flag-il"],
		["\ud83c\uddf2", "flag-im"],
		["\ud83c\uddf3", "flag-in"],
		["\ud83c\uddf4", "flag-io"],
		["\ud83c\uddf6", "flag-iq"],
		["\ud83c\uddf7", "flag-ir"],
		["\ud83c\uddf8", "flag-is"],
		["\ud83c\uddf9", "flag-it"],
		["\ud83c\uddea", "flag-je"],
		["\ud83c\uddf2", "flag-jm"],
		["\ud83c\uddf4", "flag-jo"],
		["\ud83c\uddf5", "flag-jp"],
		["\ud83c\uddea", "flag-ke"],
		["\ud83c\uddec", "flag-kg"],
		["\ud83c\udded", "flag-kh"],
		["\ud83c\uddee", "flag-ki"],
		["\ud83c\uddf2", "flag-km"],
		["\ud83c\uddf3", "flag-kn"],
		["\ud83c\uddf5", "flag-kp"],
		["\ud83c\uddf7", "flag-kr"],
		["\ud83c\uddfc", "flag-kw"],
		["\ud83c\uddfe", "flag-ky"],
		["\ud83c\uddff", "flag-kz"],
		["\ud83c\udde6", "flag-la"],
		["\ud83c\udde7", "flag-lb"],
		["\ud83c\udde8", "flag-lc"],
		["\ud83c\uddee", "flag-li"],
		["\ud83c\uddf0", "flag-lk"],
		["\ud83c\uddf7", "flag-lr"],
		["\ud83c\uddf8", "flag-ls"],
		["\ud83c\uddf9", "flag-lt"],
		["\ud83c\uddfa", "flag-lu"],
		["\ud83c\uddfb", "flag-lv"],
		["\ud83c\uddfe", "flag-ly"],
		["\ud83c\udde6", "flag-ma"],
		["\ud83c\udde8", "flag-mc"],
		["\ud83c\udde9", "flag-md"],
		["\ud83c\uddea", "flag-me"],
		["\ud83c\uddeb", "flag-mf"],
		["\ud83c\uddec", "flag-mg"],
		["\ud83c\udded", "flag-mh"],
		["\ud83c\uddf0", "flag-mk"],
		["\ud83c\uddf1", "flag-ml"],
		["\ud83c\uddf2", "flag-mm"],
		["\ud83c\uddf3", "flag-mn"],
		["\ud83c\uddf4", "flag-mo"],
		["\ud83c\uddf5", "flag-mp"],
		["\ud83c\uddf6", "flag-mq"],
		["\ud83c\uddf7", "flag-mr"],
		["\ud83c\uddf8", "flag-ms"],
		["\ud83c\uddf9", "flag-mt"],
		["\ud83c\uddfa", "flag-mu"],
		["\ud83c\uddfb", "flag-mv"],
		["\ud83c\uddfc", "flag-mw"],
		["\ud83c\uddfd", "flag-mx"],
		["\ud83c\uddfe", "flag-my"],
		["\ud83c\uddff", "flag-mz"],
		["\ud83c\udde6", "flag-na"],
		["\ud83c\udde8", "flag-nc"],
		["\ud83c\uddea", "flag-ne"],
		["\ud83c\uddeb", "flag-nf"],
		["\ud83c\uddec", "flag-ng"],
		["\ud83c\uddee", "flag-ni"],
		["\ud83c\uddf1", "flag-nl"],
		["\ud83c\uddf4", "flag-no"],
		["\ud83c\uddf5", "flag-np"],
		["\ud83c\uddf7", "flag-nr"],
		["\ud83c\uddfa", "flag-nu"],
		["\ud83c\uddff", "flag-nz"],
		["\ud83c\uddf2", "flag-om"],
		["\ud83c\udde6", "flag-pa"],
		["\ud83c\uddea", "flag-pe"],
		["\ud83c\uddeb", "flag-pf"],
		["\ud83c\uddec", "flag-pg"],
		["\ud83c\udded", "flag-ph"],
		["\ud83c\uddf0", "flag-pk"],
		["\ud83c\uddf1", "flag-pl"],
		["\ud83c\uddf2", "flag-pm"],
		["\ud83c\uddf3", "flag-pn"],
		["\ud83c\uddf7", "flag-pr"],
		["\ud83c\uddf8", "flag-ps"],
		["\ud83c\uddf9", "flag-pt"],
		["\ud83c\uddfc", "flag-pw"],
		["\ud83c\uddfe", "flag-py"],
		["\ud83c\udde6", "flag-qa"],
		["\ud83c\uddea", "flag-re"],
		["\ud83c\uddf4", "flag-ro"],
		["\ud83c\uddf8", "flag-rs"],
		["\ud83c\uddfa", "flag-ru"],
		["\ud83c\uddfc", "flag-rw"],
		["\ud83c\udde6", "flag-sa"],
		["\ud83c\udde7", "flag-sb"],
		["\ud83c\udde8", "flag-sc"],
		["\ud83c\udde9", "flag-sd"],
		["\ud83c\uddea", "flag-se"],
		["\ud83c\uddec", "flag-sg"],
		["\ud83c\udded", "flag-sh"],
		["\ud83c\uddee", "flag-si"],
		["\ud83c\uddef", "flag-sj"],
		["\ud83c\uddf0", "flag-sk"],
		["\ud83c\uddf1", "flag-sl"],
		["\ud83c\uddf2", "flag-sm"],
		["\ud83c\uddf3", "flag-sn"],
		["\ud83c\uddf4", "flag-so"],
		["\ud83c\uddf7", "flag-sr"],
		["\ud83c\uddf8", "flag-ss"],
		["\ud83c\uddf9", "flag-st"],
		["\ud83c\uddfb", "flag-sv"],
		["\ud83c\uddfd", "flag-sx"],
		["\ud83c\uddfe", "flag-sy"],
		["\ud83c\uddff", "flag-sz"],
		["\ud83c\udde6", "flag-ta"],
		["\ud83c\udde8", "flag-tc"],
		["\ud83c\udde9", "flag-td"],
		["\ud83c\uddeb", "flag-tf"],
		["\ud83c\uddec", "flag-tg"],
		["\ud83c\udded", "flag-th"],
		["\ud83c\uddef", "flag-tj"],
		["\ud83c\uddf0", "flag-tk"],
		["\ud83c\uddf1", "flag-tl"],
		["\ud83c\uddf2", "flag-tm"],
		["\ud83c\uddf3", "flag-tn"],
		["\ud83c\uddf4", "flag-to"],
		["\ud83c\uddf7", "flag-tr"],
		["\ud83c\uddf9", "flag-tt"],
		["\ud83c\uddfb", "flag-tv"],
		["\ud83c\uddfc", "flag-tw"],
		["\ud83c\uddff", "flag-tz"],
		["\ud83c\udde6", "flag-ua"],
		["\ud83c\uddec", "flag-ug"],
		["\ud83c\uddf2", "flag-um"],
		["\ud83c\uddf8", "flag-us"],
		["\ud83c\uddfe", "flag-uy"],
		["\ud83c\uddff", "flag-uz"],
		["\ud83c\udde6", "flag-va"],
		["\ud83c\udde8", "flag-vc"],
		["\ud83c\uddea", "flag-ve"],
		["\ud83c\uddec", "flag-vg"],
		["\ud83c\uddee", "flag-vi"],
		["\ud83c\uddf3", "flag-vn"],
		["\ud83c\uddfa", "flag-vu"],
		["\ud83c\uddeb", "flag-wf"],
		["\ud83c\uddf8", "flag-ws"],
		["\ud83c\uddf0", "flag-xk"],
		["\ud83c\uddea", "flag-ye"],
		["\ud83c\uddf9", "flag-yt"],
		["\ud83c\udde6", "flag-za"],
		["\ud83c\uddf2", "flag-zm"],
		["\ud83c\uddfc", "flag-zw"],
		["\ud83d\udc66", "man-man-boy"],
		["\ud83d\udc66", "man-man-boy-boy"],
		["\ud83d\udc67", "man-man-girl"],
		["\ud83d\udc66", "man-man-girl-boy"],
		["\ud83d\udc67", "man-man-girl-girl"],
		["\ud83d\udc66", "man-woman-boy"],
		["\ud83d\udc66", "man-woman-boy-boy"],
		["\ud83d\udc67", "man-woman-girl"],
		["\ud83d\udc66", "man-woman-girl-boy"],
		["\ud83d\udc67", "man-woman-girl-girl"],
		["\ud83d\udc68", "man-heart-man"],
		["\ud83d\udc68", "man-kiss-man"],
		["\ud83d\udc66", "woman-woman-boy"],
		["\ud83d\udc66", "woman-woman-boy-boy"],
		["\ud83d\udc67", "woman-woman-girl"],
		["\ud83d\udc66", "woman-woman-girl-boy"],
		["\ud83d\udc67", "woman-woman-girl-girl"],
		["\ud83d\udc69", "woman-heart-woman"],
		["\ud83d\udc69", "woman-kiss-woman"]
	];

export var ASCII2 =
{
	":broken_heart:": ["</3"],
	":heart:": ["<3"],
	":innocent:": ["O:-)", "0:-3", "0:3", "0:-)", "0:)", "0;^)", "O:)", "O;-)", "O=)", "0;-)", "O:-3", "O:3"],
	":joy:": [":')", ":'-)"],
	":smiley:": [":-D", ":D", "=D"],
	":smile:": [":-)", ":)", "=]", "=)", ":]"],
	":sweat_smile:": ["':-)", "':)", "'=)", "':D", "':-D", "'=D"],
	":laughing:": [">:)", ">;)", ">:-)", ">=)"],
	":wink:": [";)", ";-)", "*-)", "*)", ";-]", ";]", ";D", ";^)"],
	":sweat:": ["':(", "':-(", "'=("],
	":kissing_heart:": [":*", ":-*", "=*", ":^*"],
	":stuck_out_tongue_winking_eye:": [">:P", "X-P", "x-p"],
	":disappointed:": [">:[", ":-(", ":(", ":-[", ":[", "=("],
	":angry:": [">:(", ">:-(", ":@"],
	":cry:": [":'(", ":'-(", ";(", ";-("],
	":persevere:": [">.<"],
	":flushed:": [":$", "=$"],
	":dizzy_face:": ["#-)", "#)", "%-)", "%)", "X)", "X-)"],
	":ok_woman:": ["*\\0/*", "\\0/", "*\\O/*", "\\O/"],
	":sunglasses:": ["B-)", "B)", "8)", "8-)", "B-D", "8-D"],
	":expressionless:": ["-_-"],
	":confused:": [">:\\", ">:/", ":-/", ":-.", ":/", ":\\", "=/", ":L", "=L"],
	":stuck_out_tongue:": [":P", ":-P", "=P", ":-p", ":p", "=p", ":-b", ":b", "d:"],
	":open_mouth:": [":-O", ":O", ":-o", "O_O", ">:O", ":o"],
	":no_mouth:": [":-x", ":-X", ":X", ":-#", ":#", "=X", "=x", ":x", "=#"]
};

export var EMOJI =
{
	"👩‍👩‍👦‍👦": [100, 1460, 964],
	"👨‍👩‍👦‍👦": [0, 1460, 959],
	"👨‍👨‍👦‍👦": [80, 1480, 955],
	"👨‍👨‍👧‍👦": [60, 1480, 957],
	"👩‍👩‍👧‍👧": [0, 1480, 967],
	"👨‍👨‍👧‍👧": [100, 1480, 958],
	"👩‍❤️‍💋‍👩": [20, 1440, 1091],
	"👨‍❤️‍💋‍👨": [40, 1440, 1090],
	"👩‍👩‍👧‍👦": [80, 1460, 966],
	"👨‍👩‍👧‍👦": [100, 1440, 961],
	"👨‍👩‍👧‍👧": [20, 1460, 962],
	"👩‍❤️‍👩": [80, 1420, 1095],
	"👩👩👦👦": [100, 1460, 964],
	"👨‍❤️‍👨": [100, 1420, 1094],
	"👨👨👧👧": [100, 1480, 958],
	"👨👨👧👦": [60, 1480, 957],
	"👩👩👧👦": [80, 1460, 966],
	"👨‍👨‍👧": [40, 1480, 956],
	"👨‍👨‍👦": [20, 1480, 954],
	"👨‍👩‍👧": [80, 1440, 960],
	"👩‍👩‍👧": [60, 1460, 965],
	"👩👩👧👧": [0, 1480, 967],
	"👨👩👧👦": [100, 1440, 961],
	"👩‍👩‍👦": [40, 1460, 963],
	"👨👩👦👦": [0, 1460, 959],
	"👨👨👦👦": [80, 1480, 955],
	"👨👩👧👧": [20, 1460, 962],
	"👨❤💋👨": [40, 1440, 1090],
	"👩❤💋👩": [20, 1440, 1091],
	"👨👩👧": [80, 1440, 960],
	"👩👩👧": [60, 1460, 965],
	"👩👩👦": [40, 1460, 963],
	"👨👨👦": [20, 1480, 954],
	"👨👨👧": [40, 1480, 956],
	"️👆🏽": [0, 580, 845],
	"️👆🏿": [40, 580, 847],
	"️👆🏾": [20, 580, 846],
	"️👌🏻": [80, 440, 879],
	"👨❤👨": [100, 1420, 1094],
	"👩❤👩": [80, 1420, 1095],
	"️👆🏼": [100, 560, 844],
	"️👆🏻": [80, 560, 843],
	"️👌🏿": [40, 460, 883],
	"️👌🏾": [20, 460, 882],
	"️👌🏽": [0, 460, 881],
	"️👌🏼": [100, 440, 880],
	"👁‍🗨": [20, 4480, 827],
	"🇬🇱": [80, 4860, 306],
	"👌🏻": [80, 440, 879],
	"🙌🏼": [100, 280, 1457],
	"👌🏼": [100, 440, 880],
	"🙌🏽": [0, 300, 1458],
	"👌🏽": [0, 460, 881],
	"🙌🏾": [20, 300, 1459],
	"👌🏾": [20, 460, 882],
	"🙌🏿": [40, 300, 1460],
	"👌🏿": [40, 460, 883],
	"🇫🇮": [80, 4820, 292],
	"🇫🇯": [60, 4820, 293],
	"🇫🇴": [40, 4820, 296],
	"🇫🇰": [20, 4820, 294],
	"🇪🇺": [0, 4820, 291],
	"👐🏻": [80, 480, 903],
	"👐🏼": [100, 480, 904],
	"👐🏽": [0, 500, 905],
	"👐🏾": [20, 500, 906],
	"👐🏿": [40, 500, 907],
	"💪🏻": [80, 500, 1121],
	"💪🏼": [100, 500, 1122],
	"💪🏽": [0, 520, 1123],
	"💪🏾": [20, 520, 1124],
	"💪🏿": [40, 520, 1125],
	"🙏🏻": [80, 520, 1474],
	"🙏🏼": [100, 520, 1475],
	"🙏🏽": [0, 540, 1476],
	"🙏🏾": [20, 540, 1477],
	"🙏🏿": [40, 540, 1478],
	"🇿🇼": [0, 5400, 469],
	"☝️🏻": [80, 540, 64],
	"🇪🇹": [100, 4800, 290],
	"☝️🏼": [100, 540, 65],
	"🇪🇪": [80, 4800, 285],
	"☝️🏽": [0, 560, 66],
	"🇪🇷": [60, 4800, 288],
	"☝️🏾": [20, 560, 67],
	"🇬🇶": [40, 4800, 310],
	"☝️🏿": [40, 560, 68],
	"🇸🇻": [20, 4800, 430],
	"🇪🇬": [0, 4800, 286],
	"👏🏻": [80, 300, 897],
	"👆🏻": [80, 560, 843],
	"👏🏼": [100, 300, 898],
	"👆🏼": [100, 560, 844],
	"👏🏽": [0, 320, 899],
	"👆🏽": [0, 580, 845],
	"👏🏾": [20, 320, 900],
	"👆🏾": [20, 580, 846],
	"👏🏿": [40, 320, 901],
	"👆🏿": [40, 580, 847],
	"👇🏻": [80, 580, 849],
	"👇🏼": [100, 580, 850],
	"👇🏽": [0, 600, 851],
	"👇🏾": [20, 600, 852],
	"👇🏿": [40, 600, 853],
	"👈🏻": [80, 600, 855],
	"👈🏼": [100, 600, 856],
	"👈🏽": [0, 620, 857],
	"👈🏾": [20, 620, 858],
	"👈🏿": [40, 620, 859],
	"👉🏻": [80, 620, 861],
	"👉🏼": [100, 620, 862],
	"👉🏽": [0, 640, 863],
	"👉🏾": [20, 640, 864],
	"👉🏿": [40, 640, 865],
	"🖕🏻": [80, 640, 1323],
	"🖕🏼": [100, 640, 1324],
	"🖕🏽": [0, 660, 1325],
	"🖕🏾": [20, 660, 1326],
	"🖕🏿": [40, 660, 1327],
	"🖐🏻": [80, 660, 1317],
	"🖐🏼": [100, 660, 1318],
	"🖐🏽": [0, 680, 1319],
	"🖐🏾": [20, 680, 1320],
	"🖐🏿": [40, 680, 1321],
	"🤘🏻": [80, 680, 1600],
	"🤘🏼": [100, 680, 1601],
	"🤘🏽": [0, 700, 1602],
	"🤘🏾": [20, 700, 1603],
	"🤘🏿": [40, 700, 1604],
	"🖖🏻": [80, 700, 1329],
	"🖖🏼": [100, 700, 1330],
	"🖖🏽": [0, 720, 1331],
	"🖖🏾": [20, 720, 1332],
	"🖖🏿": [40, 720, 1333],
	"🇿🇲": [100, 5380, 468],
	"🇪🇨": [100, 4780, 284],
	"🇩🇴": [80, 4780, 282],
	"🇩🇲": [60, 4780, 281],
	"🇩🇯": [40, 4780, 279],
	"🇩🇰": [20, 4780, 280],
	"💅🏻": [80, 740, 1065],
	"💅🏼": [100, 740, 1066],
	"💅🏽": [0, 760, 1067],
	"💅🏾": [20, 760, 1068],
	"💅🏿": [40, 760, 1069],
	"👂🏻": [0, 780, 829],
	"👂🏼": [20, 780, 830],
	"👂🏽": [40, 780, 831],
	"👂🏾": [60, 780, 832],
	"👂🏿": [80, 780, 833],
	"👃🏻": [0, 800, 835],
	"👃🏼": [20, 800, 836],
	"👃🏽": [40, 800, 837],
	"👃🏾": [60, 800, 838],
	"👃🏿": [80, 800, 839],
	"👶🏻": [100, 820, 1015],
	"👶🏼": [0, 840, 1016],
	"👶🏽": [20, 840, 1017],
	"👶🏾": [40, 840, 1018],
	"👶🏿": [60, 840, 1019],
	"👦🏻": [100, 840, 930],
	"👦🏼": [0, 860, 931],
	"👦🏽": [20, 860, 932],
	"👦🏾": [40, 860, 933],
	"👦🏿": [60, 860, 934],
	"👧🏻": [100, 860, 936],
	"👧🏼": [0, 880, 937],
	"👧🏽": [20, 880, 938],
	"👧🏾": [40, 880, 939],
	"👧🏿": [60, 880, 940],
	"👨🏻": [100, 880, 942],
	"👨🏼": [0, 900, 943],
	"👨🏽": [20, 900, 944],
	"👨🏾": [40, 900, 945],
	"👨🏿": [60, 900, 946],
	"👩🏻": [100, 900, 948],
	"👩🏼": [0, 920, 949],
	"👩🏽": [20, 920, 950],
	"👩🏾": [40, 920, 951],
	"👩🏿": [60, 920, 952],
	"👱🏻": [100, 920, 985],
	"👱🏼": [0, 940, 986],
	"👱🏽": [20, 940, 987],
	"👱🏾": [40, 940, 988],
	"👱🏿": [60, 940, 989],
	"👴🏻": [100, 940, 1003],
	"👴🏼": [0, 960, 1004],
	"👴🏽": [20, 960, 1005],
	"👴🏾": [40, 960, 1006],
	"👴🏿": [60, 960, 1007],
	"👵🏻": [100, 960, 1009],
	"👵🏼": [0, 980, 1010],
	"👵🏽": [20, 980, 1011],
	"👵🏾": [40, 980, 1012],
	"👵🏿": [60, 980, 1013],
	"👲🏻": [100, 980, 991],
	"👲🏼": [0, 1000, 992],
	"👲🏽": [20, 1000, 993],
	"👲🏾": [40, 1000, 994],
	"👲🏿": [60, 1000, 995],
	"👳🏻": [100, 1000, 997],
	"👳🏼": [0, 1020, 998],
	"👳🏽": [20, 1020, 999],
	"👳🏾": [40, 1020, 1000],
	"👳🏿": [60, 1020, 1001],
	"👮🏻": [100, 1020, 972],
	"👮🏼": [0, 1040, 973],
	"👮🏽": [20, 1040, 974],
	"👮🏾": [40, 1040, 975],
	"👮🏿": [60, 1040, 976],
	"👷🏻": [100, 1040, 1021],
	"👷🏼": [0, 1060, 1022],
	"👷🏽": [20, 1060, 1023],
	"👷🏾": [40, 1060, 1024],
	"👷🏿": [60, 1060, 1025],
	"💂🏻": [100, 1060, 1052],
	"💂🏼": [0, 1080, 1053],
	"💂🏽": [20, 1080, 1054],
	"💂🏾": [40, 1080, 1055],
	"💂🏿": [60, 1080, 1056],
	"🎅🏻": [0, 1100, 617],
	"🎅🏼": [20, 1100, 618],
	"🎅🏽": [40, 1100, 619],
	"🎅🏾": [60, 1100, 620],
	"🎅🏿": [80, 1100, 621],
	"👼🏻": [0, 1120, 1036],
	"👼🏼": [20, 1120, 1037],
	"👼🏽": [40, 1120, 1038],
	"👼🏾": [60, 1120, 1039],
	"👼🏿": [80, 1120, 1040],
	"👸🏻": [0, 1140, 1027],
	"👸🏼": [20, 1140, 1028],
	"👸🏽": [40, 1140, 1029],
	"👸🏾": [60, 1140, 1030],
	"👸🏿": [80, 1140, 1031],
	"👰🏻": [0, 1160, 979],
	"👰🏼": [20, 1160, 980],
	"👰🏽": [40, 1160, 981],
	"👰🏾": [60, 1160, 982],
	"👰🏿": [80, 1160, 983],
	"🚶🏻": [0, 1180, 1549],
	"🚶🏼": [20, 1180, 1550],
	"🚶🏽": [40, 1180, 1551],
	"🚶🏾": [60, 1180, 1552],
	"🚶🏿": [80, 1180, 1553],
	"🏃🏻": [0, 1200, 679],
	"🏃🏼": [20, 1200, 680],
	"🏃🏽": [40, 1200, 681],
	"🏃🏾": [60, 1200, 682],
	"🏃🏿": [80, 1200, 683],
	"💃🏻": [0, 1220, 1058],
	"💃🏼": [20, 1220, 1059],
	"💃🏽": [40, 1220, 1060],
	"💃🏾": [60, 1220, 1061],
	"💃🏿": [80, 1220, 1062],
	"🙇🏻": [80, 1240, 1441],
	"🙇🏼": [100, 1240, 1442],
	"🙇🏽": [0, 1260, 1443],
	"🙇🏾": [20, 1260, 1444],
	"🙇🏿": [40, 1260, 1445],
	"💁🏻": [80, 1260, 1046],
	"💁🏼": [100, 1260, 1047],
	"💁🏽": [0, 1280, 1048],
	"💁🏾": [20, 1280, 1049],
	"💁🏿": [40, 1280, 1050],
	"🙅🏻": [80, 1280, 1429],
	"🙅🏼": [100, 1280, 1430],
	"🙅🏽": [0, 1300, 1431],
	"🙅🏾": [20, 1300, 1432],
	"🙅🏿": [40, 1300, 1433],
	"🙆🏻": [80, 1300, 1435],
	"🙆🏼": [100, 1300, 1436],
	"🙆🏽": [0, 1320, 1437],
	"🙆🏾": [20, 1320, 1438],
	"🙆🏿": [40, 1320, 1439],
	"🙋🏻": [80, 1320, 1450],
	"🙋🏼": [100, 1320, 1451],
	"🙋🏽": [0, 1340, 1452],
	"🙋🏾": [20, 1340, 1453],
	"🙋🏿": [40, 1340, 1454],
	"🙎🏻": [80, 1340, 1468],
	"🙎🏼": [100, 1340, 1469],
	"🙎🏽": [0, 1360, 1470],
	"🙎🏾": [20, 1360, 1471],
	"🙎🏿": [40, 1360, 1472],
	"🙍🏻": [80, 1360, 1462],
	"🙍🏼": [100, 1360, 1463],
	"🙍🏽": [0, 1380, 1464],
	"🙍🏾": [20, 1380, 1465],
	"🙍🏿": [40, 1380, 1466],
	"💇🏻": [80, 1380, 1077],
	"💇🏼": [100, 1380, 1078],
	"💇🏽": [0, 1400, 1079],
	"💇🏾": [20, 1400, 1080],
	"💇🏿": [40, 1400, 1081],
	"💆🏻": [80, 1400, 1071],
	"💆🏼": [100, 1400, 1072],
	"💆🏽": [0, 1420, 1073],
	"💆🏾": [20, 1420, 1074],
	"💆🏿": [40, 1420, 1075],
	"👋🏻": [80, 320, 873],
	"👋🏼": [100, 320, 874],
	"👋🏽": [0, 340, 875],
	"👋🏾": [20, 340, 876],
	"👋🏿": [40, 340, 877],
	"👍🏻": [80, 340, 885],
	"👍🏼": [100, 340, 886],
	"👍🏽": [0, 360, 887],
	"👍🏾": [20, 360, 888],
	"👍🏿": [40, 360, 889],
	"👎🏻": [80, 360, 891],
	"👎🏼": [100, 360, 892],
	"👎🏽": [0, 380, 893],
	"👎🏾": [20, 380, 894],
	"👎🏿": [40, 380, 895],
	"👊🏻": [80, 380, 867],
	"👊🏼": [100, 380, 868],
	"👊🏽": [0, 400, 869],
	"👊🏾": [20, 400, 870],
	"👊🏿": [40, 400, 871],
	"🇬🇷": [60, 4860, 311],
	"🇬🇮": [40, 4860, 305],
	"🇬🇭": [20, 4860, 304],
	"🇩🇪": [0, 4860, 278],
	"🇬🇪": [100, 4840, 301],
	"✌️🏻": [80, 420, 157],
	"🇬🇲": [80, 4840, 307],
	"✌️🏼": [100, 420, 158],
	"🙌🏻": [80, 280, 1456],
	"🇬🇦": [60, 4840, 298],
	"✌️🏽": [0, 440, 159],
	"🇹🇫": [40, 4840, 436],
	"✌️🏾": [20, 440, 160],
	"🇵🇫": [20, 4840, 396],
	"✌️🏿": [40, 440, 161],
	"🇬🇫": [0, 4840, 302],
	"🇾🇪": [80, 5380, 465],
	"🇪🇭": [60, 5380, 287],
	"🇼🇫": [40, 5380, 462],
	"🇨🇿": [0, 4780, 277],
	"🇻🇳": [20, 5380, 460],
	"🇻🇪": [0, 5380, 457],
	"🇻🇦": [100, 5360, 455],
	"🇨🇾": [100, 4760, 276],
	"🇻🇺": [80, 5360, 461],
	"🇨🇼": [80, 4760, 274],
	"🇺🇿": [60, 5360, 454],
	"🇺🇾": [40, 5360, 453],
	"🇺🇸": [20, 5360, 452],
	"🇬🇧": [0, 5360, 299],
	"🇦🇪": [100, 5340, 224],
	"🇺🇦": [80, 5340, 450],
	"🇺🇬": [60, 5340, 451],
	"🇻🇮": [40, 5340, 459],
	"🇹🇻": [20, 5340, 447],
	"🇹🇨": [0, 5340, 434],
	"🇹🇲": [100, 5320, 442],
	"🇹🇷": [80, 5320, 445],
	"🇹🇳": [60, 5320, 443],
	"🇹🇹": [40, 5320, 446],
	"🚣🏻": [80, 2400, 1515],
	"🚣🏼": [100, 2400, 1516],
	"🚣🏽": [0, 2420, 1517],
	"🚣🏾": [20, 2420, 1518],
	"🚣🏿": [40, 2420, 1519],
	"🏊🏻": [80, 2420, 701],
	"🏊🏼": [100, 2420, 702],
	"🏊🏽": [0, 2440, 703],
	"🏊🏾": [20, 2440, 704],
	"🏊🏿": [40, 2440, 705],
	"🏄🏻": [80, 2440, 685],
	"🏄🏼": [100, 2440, 686],
	"🏄🏽": [0, 2460, 687],
	"🏄🏾": [20, 2460, 688],
	"🏄🏿": [40, 2460, 689],
	"🛀🏻": [80, 2460, 1564],
	"🛀🏼": [100, 2460, 1565],
	"🛀🏽": [0, 2480, 1566],
	"🛀🏾": [20, 2480, 1567],
	"🛀🏿": [40, 2480, 1568],
	"🇹🇴": [20, 5320, 444],
	"🇨🇺": [60, 4760, 272],
	"🇭🇷": [40, 4760, 319],
	"🇨🇮": [20, 4760, 265],
	"🇨🇷": [0, 4760, 271],
	"🇨🇰": [100, 4740, 266],
	"🏋🏻": [80, 2500, 707],
	"🏋🏼": [100, 2500, 708],
	"🏋🏽": [0, 2520, 709],
	"🏋🏾": [20, 2520, 710],
	"🏋🏿": [40, 2520, 711],
	"🚴🏻": [80, 2520, 1537],
	"🚴🏼": [100, 2520, 1538],
	"🚴🏽": [0, 2540, 1539],
	"🚴🏾": [20, 2540, 1540],
	"🚴🏿": [40, 2540, 1541],
	"🚵🏻": [80, 2540, 1543],
	"🚵🏼": [100, 2540, 1544],
	"🚵🏽": [0, 2560, 1545],
	"🚵🏾": [20, 2560, 1546],
	"🚵🏿": [40, 2560, 1547],
	"🏇🏻": [80, 2560, 693],
	"🏇🏼": [100, 2560, 694],
	"🏇🏽": [0, 2580, 695],
	"🏇🏾": [20, 2580, 696],
	"🏇🏿": [40, 2580, 697],
	"🇹🇰": [0, 5320, 440],
	"🇹🇬": [100, 5300, 437],
	"🇹🇱": [80, 5300, 441],
	"🇹🇭": [60, 5300, 438],
	"🇹🇿": [40, 5300, 449],
	"🇹🇯": [20, 5300, 439],
	"🇹🇼": [0, 5300, 448],
	"🇸🇾": [100, 5280, 432],
	"🇨🇭": [80, 5280, 264],
	"🇸🇪": [60, 5280, 418],
	"🇸🇿": [40, 5280, 433],
	"🇸🇷": [20, 5280, 427],
	"🇸🇩": [0, 5280, 417],
	"🇻🇨": [100, 5260, 456],
	"🇵🇲": [80, 5260, 401],
	"🇱🇨": [60, 5260, 350],
	"🇰🇳": [40, 5260, 342],
	"🇸🇭": [20, 5260, 420],
	"🇧🇱": [0, 5260, 248],
	"🇱🇰": [100, 5240, 352],
	"🇪🇸": [80, 5240, 289],
	"🇸🇸": [60, 5240, 428],
	"🇰🇷": [40, 5240, 344],
	"🇿🇦": [20, 5240, 467],
	"🇸🇴": [0, 5240, 426],
	"🇸🇧": [100, 5220, 415],
	"🇬🇸": [80, 5220, 312],
	"🇸🇮": [60, 5220, 421],
	"🇸🇰": [40, 5220, 422],
	"🇸🇽": [20, 5220, 431],
	"🇸🇬": [0, 5220, 419],
	"🇸🇱": [100, 5200, 423],
	"🇸🇨": [80, 5200, 416],
	"🇷🇸": [60, 5200, 411],
	"🇸🇳": [40, 5200, 425],
	"🇸🇦": [20, 5200, 414],
	"🇸🇹": [0, 5200, 429],
	"🇸🇲": [100, 5180, 424],
	"🇼🇸": [80, 5180, 463],
	"🇷🇼": [60, 5180, 413],
	"🇷🇺": [40, 5180, 412],
	"🇷🇴": [20, 5180, 410],
	"🇷🇪": [0, 5180, 409],
	"🇶🇦": [100, 5160, 408],
	"🇵🇷": [80, 5160, 403],
	"🇵🇹": [60, 5160, 405],
	"🇵🇱": [40, 5160, 400],
	"🇵🇳": [20, 5160, 402],
	"🇵🇭": [0, 5160, 398],
	"🇵🇪": [100, 5140, 395],
	"🇵🇾": [80, 5140, 407],
	"🇵🇬": [60, 5140, 397],
	"🇵🇦": [40, 5140, 394],
	"🇵🇸": [20, 5140, 404],
	"🇵🇼": [0, 5140, 406],
	"🇵🇰": [100, 5120, 399],
	"🇴🇲": [80, 5120, 393],
	"🇳🇴": [60, 5120, 388],
	"🇨🇩": [80, 4740, 261],
	"🇨🇬": [60, 4740, 263],
	"🇰🇲": [40, 4740, 341],
	"🇲🇵": [40, 5120, 370],
	"🇰🇵": [20, 5120, 343],
	"🇳🇫": [0, 5120, 384],
	"🇨🇴": [20, 4740, 270],
	"🇨🇨": [0, 4740, 260],
	"🇨🇽": [100, 4720, 275],
	"🇳🇺": [100, 5100, 391],
	"🇳🇬": [80, 5100, 385],
	"🇳🇪": [60, 5100, 383],
	"🇳🇮": [40, 5100, 386],
	"🇳🇿": [20, 5100, 392],
	"🇳🇨": [0, 5100, 382],
	"🇳🇱": [100, 5080, 387],
	"🇳🇵": [80, 5080, 389],
	"🇳🇷": [60, 5080, 390],
	"🇳🇦": [40, 5080, 381],
	"🇲🇲": [20, 5080, 367],
	"🇲🇿": [0, 5080, 380],
	"🇲🇦": [100, 5060, 359],
	"🇲🇸": [80, 5060, 373],
	"🇨🇳": [80, 4720, 269],
	"🇨🇱": [60, 4720, 267],
	"🇲🇪": [60, 5060, 362],
	"🇲🇳": [40, 5060, 368],
	"🇲🇨": [20, 5060, 360],
	"🇲🇩": [0, 5060, 361],
	"🇫🇲": [100, 5040, 295],
	"🇲🇽": [80, 5040, 378],
	"🇹🇩": [40, 4720, 435],
	"🇾🇹": [60, 5040, 466],
	"🇨🇫": [20, 4720, 262],
	"🇰🇾": [0, 4720, 346],
	"🇧🇶": [100, 4700, 252],
	"🇨🇻": [80, 4700, 273],
	"🇮🇨": [60, 4700, 322],
	"🇨🇦": [40, 4700, 259],
	"🇨🇲": [20, 4700, 268],
	"🇰🇭": [0, 4700, 339],
	"🇧🇮": [100, 4680, 246],
	"🇧🇫": [80, 4680, 243],
	"🇧🇬": [60, 4680, 244],
	"🇧🇳": [40, 4680, 250],
	"🇲🇺": [40, 5040, 375],
	"🇲🇷": [20, 5040, 372],
	"🇲🇶": [0, 5040, 371],
	"🇲🇭": [100, 5020, 364],
	"🇲🇹": [80, 5020, 374],
	"🇲🇱": [60, 5020, 366],
	"🇲🇻": [40, 5020, 376],
	"🇲🇾": [20, 5020, 379],
	"🇲🇼": [0, 5020, 377],
	"🇲🇬": [100, 5000, 363],
	"🇲🇰": [80, 5000, 365],
	"🇲🇴": [60, 5000, 369],
	"🇱🇺": [40, 5000, 356],
	"🇱🇹": [20, 5000, 355],
	"🇱🇮": [0, 5000, 351],
	"🇱🇾": [100, 4980, 358],
	"🇱🇷": [80, 4980, 353],
	"🇱🇸": [60, 4980, 354],
	"🇱🇧": [40, 4980, 349],
	"🇱🇻": [20, 4980, 357],
	"🇱🇦": [0, 4980, 348],
	"🇰🇬": [100, 4960, 338],
	"🇰🇼": [80, 4960, 345],
	"🇽🇰": [60, 4960, 464],
	"🇰🇮": [40, 4960, 340],
	"🇰🇪": [20, 4960, 337],
	"🇻🇬": [20, 4680, 458],
	"🇮🇴": [0, 4680, 328],
	"🇰🇿": [0, 4960, 347],
	"🇯🇴": [100, 4940, 335],
	"🇯🇪": [80, 4940, 333],
	"🇯🇵": [60, 4940, 336],
	"🇯🇲": [40, 4940, 334],
	"🇮🇹": [20, 4940, 332],
	"🇮🇱": [0, 4940, 325],
	"🇮🇲": [100, 4920, 326],
	"🇮🇪": [80, 4920, 324],
	"🇮🇶": [60, 4920, 329],
	"🇮🇷": [40, 4920, 330],
	"🇮🇩": [20, 4920, 323],
	"🇮🇳": [0, 4920, 327],
	"🇮🇸": [100, 4900, 331],
	"🇭🇺": [80, 4900, 321],
	"🇭🇰": [60, 4900, 317],
	"🇭🇳": [40, 4900, 318],
	"🇭🇹": [20, 4900, 320],
	"🇬🇾": [0, 4900, 316],
	"🇬🇼": [100, 4880, 315],
	"🇬🇳": [80, 4880, 308],
	"🇬🇬": [60, 4880, 303],
	"🇧🇷": [100, 4660, 253],
	"🇧🇼": [80, 4660, 256],
	"🇬🇹": [40, 4880, 313],
	"🇬🇺": [20, 4880, 314],
	"🇬🇵": [0, 4880, 309],
	"🇬🇩": [100, 4860, 300],
	"🇫🇷": [100, 4820, 297],
	"👁🗨": [20, 4480, 827],
	"🇦🇫": [0, 4580, 225],
	"🇦🇽": [20, 4580, 237],
	"🇦🇱": [40, 4580, 228],
	"🇩🇿": [60, 4580, 283],
	"🇦🇸": [80, 4580, 233],
	"🇦🇩": [100, 4580, 223],
	"🇦🇴": [0, 4600, 230],
	"🇦🇮": [20, 4600, 227],
	"🇦🇶": [40, 4600, 231],
	"🇦🇬": [60, 4600, 226],
	"🇦🇷": [80, 4600, 232],
	"🇦🇲": [100, 4600, 229],
	"🇦🇼": [0, 4620, 236],
	"🇦🇺": [20, 4620, 235],
	"🇦🇹": [40, 4620, 234],
	"🇦🇿": [60, 4620, 238],
	"🇧🇸": [80, 4620, 254],
	"🇧🇭": [100, 4620, 245],
	"🇧🇩": [0, 4640, 241],
	"🇧🇧": [20, 4640, 240],
	"🇧🇾": [40, 4640, 257],
	"🇧🇪": [60, 4640, 242],
	"🇧🇿": [80, 4640, 258],
	"🇧🇯": [100, 4640, 247],
	"🇧🇲": [0, 4660, 249],
	"🇧🇹": [20, 4660, 255],
	"🇧🇴": [40, 4660, 251],
	"🇧🇦": [60, 4660, 239],
	"️🌥": [100, 2000, 520],
	"️♠️": [40, 4460, 91],
	"*️⃣": [80, 4260, 2],
	"#️⃣": [60, 4260, 1],
	"9️⃣": [80, 4140, 12],
	"8️⃣": [60, 4140, 11],
	"7️⃣": [40, 4140, 10],
	"6️⃣": [20, 4140, 9],
	"5️⃣": [0, 4140, 8],
	"4️⃣": [100, 4120, 7],
	"3️⃣": [80, 4120, 6],
	"2️⃣": [60, 4120, 5],
	"1️⃣": [40, 4120, 4],
	"0️⃣": [20, 4120, 3],
	"️🚰": [80, 4060, 1532],
	"🅿️": [60, 4060, 211],
	"🈂️": [20, 4040, 471],
	"️💹": [40, 4000, 1140],
	"🈯️": [20, 4000, 473],
	"🅾️": [0, 3900, 210],
	"🅱️": [60, 3880, 209],
	"🅰️": [40, 3880, 208],
	"🈷️": [60, 3840, 479],
	"️🈸": [20, 3840, 480],
	"🈚️": [0, 3840, 472],
	"⛹🏿": [40, 2500, 137],
	"⛹🏾": [20, 2500, 136],
	"⛹🏽": [0, 2500, 135],
	"⛹🏼": [100, 2480, 134],
	"⛹🏻": [80, 2480, 133],
	"🀄️": [20, 4460, 206],
	"️🌤": [60, 2000, 519],
	"️🌟": [80, 1980, 516],
	"✍🏿": [40, 740, 167],
	"✍🏾": [20, 740, 166],
	"✍🏽": [0, 740, 165],
	"✍🏼": [100, 720, 164],
	"✍🏻": [80, 720, 163],
	"️👆": [60, 560, 842],
	"☝🏿": [40, 560, 68],
	"☝🏾": [20, 560, 67],
	"☝🏽": [0, 560, 66],
	"☝🏼": [100, 540, 65],
	"☝🏻": [80, 540, 64],
	"✋🏿": [40, 480, 155],
	"✋🏾": [20, 480, 154],
	"✋🏽": [0, 480, 153],
	"✋🏼": [100, 460, 152],
	"✋🏻": [80, 460, 151],
	"️👌": [60, 440, 878],
	"✌🏿": [40, 440, 161],
	"✌🏾": [20, 440, 160],
	"✌🏽": [0, 440, 159],
	"✌🏼": [100, 420, 158],
	"✌🏻": [80, 420, 157],
	"✊🏿": [40, 420, 149],
	"✊🏾": [20, 420, 148],
	"✊🏽": [0, 420, 147],
	"✊🏼": [100, 400, 146],
	"✊🏻": [80, 400, 145],
	"🙅": [60, 1280, 1428],
	"☁️": [20, 2020, 54],
	"👍": [60, 340, 884],
	"🌧": [40, 2020, 522],
	"😌": [60, 40, 1371],
	"🌩": [80, 2020, 524],
	"⚡️": [100, 2020, 107],
	"💂": [80, 1060, 1051],
	"🔥": [0, 2040, 1247],
	"💥": [20, 2040, 1115],
	"❄️": [40, 2040, 177],
	"👉": [60, 620, 860],
	"🌨": [60, 2040, 523],
	"☃️": [80, 2040, 56],
	"😍": [80, 40, 1372],
	"⛄️": [100, 2040, 114],
	"😘": [100, 40, 1383],
	"🌬": [0, 2060, 527],
	"💨": [20, 2060, 1118],
	"🌪": [40, 2060, 525],
	"🌫": [60, 2060, 526],
	"☂️": [80, 2060, 55],
	"😗": [0, 60, 1382],
	"☔️": [100, 2060, 60],
	"😙": [20, 60, 1384],
	"💧": [0, 2080, 1117],
	"💦": [20, 2080, 1116],
	"🌊": [40, 2080, 495],
	"🍏": [0, 2100, 562],
	"🍎": [20, 2100, 561],
	"🍐": [40, 2100, 563],
	"🍊": [60, 2100, 557],
	"🍋": [80, 2100, 558],
	"🍌": [100, 2100, 559],
	"🍉": [0, 2120, 556],
	"🍇": [20, 2120, 554],
	"🍓": [40, 2120, 566],
	"🍈": [60, 2120, 555],
	"🍒": [80, 2120, 565],
	"🍑": [100, 2120, 564],
	"🍍": [0, 2140, 560],
	"🍅": [20, 2140, 552],
	"🍆": [40, 2140, 553],
	"🌶": [60, 2140, 537],
	"🌽": [80, 2140, 544],
	"🍠": [100, 2140, 579],
	"🍯": [0, 2160, 594],
	"🍞": [20, 2160, 577],
	"🧀": [40, 2160, 1610],
	"🍗": [60, 2160, 570],
	"🍖": [80, 2160, 569],
	"🍤": [100, 2160, 583],
	"🍳": [0, 2180, 598],
	"🍔": [20, 2180, 567],
	"🍟": [40, 2180, 578],
	"🌭": [60, 2180, 528],
	"🍕": [80, 2180, 568],
	"🍝": [100, 2180, 576],
	"🌮": [0, 2200, 529],
	"🌯": [20, 2200, 530],
	"🍜": [40, 2200, 575],
	"🍲": [60, 2200, 597],
	"🍥": [80, 2200, 584],
	"🍣": [100, 2200, 582],
	"🍱": [0, 2220, 596],
	"🍛": [20, 2220, 574],
	"🍙": [40, 2220, 572],
	"🍚": [60, 2220, 573],
	"🍘": [80, 2220, 571],
	"🍢": [100, 2220, 581],
	"🍡": [0, 2240, 580],
	"🍧": [20, 2240, 586],
	"🍨": [40, 2240, 587],
	"🍦": [60, 2240, 585],
	"🍰": [80, 2240, 595],
	"🎂": [100, 2240, 613],
	"🍮": [0, 2260, 593],
	"🍬": [20, 2260, 591],
	"🍭": [40, 2260, 592],
	"🍫": [60, 2260, 590],
	"🍿": [80, 2260, 610],
	"🍩": [100, 2260, 588],
	"🍪": [0, 2280, 589],
	"🍺": [20, 2280, 605],
	"🍻": [40, 2280, 606],
	"🍷": [60, 2280, 602],
	"🍸": [80, 2280, 603],
	"🍹": [100, 2280, 604],
	"🍾": [0, 2300, 609],
	"🍶": [20, 2300, 601],
	"🍵": [40, 2300, 600],
	"☕️": [60, 2300, 61],
	"🕵": [80, 1080, 1306],
	"🍼": [80, 2300, 607],
	"🍴": [100, 2300, 599],
	"🍽": [0, 2320, 608],
	"⚽️": [0, 2340, 112],
	"🎅": [100, 1080, 616],
	"🏀": [20, 2340, 675],
	"🏈": [40, 2340, 698],
	"⚾️": [60, 2340, 113],
	"👎": [60, 360, 890],
	"🎾": [80, 2340, 673],
	"🏐": [100, 2340, 716],
	"🏉": [0, 2360, 699],
	"🎱": [20, 2360, 660],
	"⛳️": [40, 2360, 127],
	"🖕": [60, 640, 1322],
	"🏌": [60, 2360, 712],
	"🏓": [80, 2360, 719],
	"🏸": [100, 2360, 753],
	"🏒": [0, 2380, 718],
	"🏑": [20, 2380, 717],
	"🏏": [40, 2380, 715],
	"🎿": [60, 2380, 674],
	"😚": [40, 60, 1385],
	"🏂": [100, 2380, 677],
	"😜": [60, 60, 1387],
	"🏹": [20, 2400, 754],
	"🎣": [40, 2400, 646],
	"🚣": [60, 2400, 1514],
	"😝": [80, 60, 1388],
	"👼": [100, 1100, 1035],
	"😛": [100, 60, 1386],
	"🤑": [0, 80, 1592],
	"🖐": [60, 660, 1316],
	"🏊": [60, 2420, 700],
	"👊": [60, 380, 866],
	"🤓": [20, 80, 1594],
	"👸": [100, 1120, 1026],
	"😎": [40, 80, 1373],
	"🤗": [60, 80, 1598],
	"🏄": [60, 2440, 684],
	"😏": [80, 80, 1374],
	"🤘": [60, 680, 1599],
	"😶": [100, 80, 1413],
	"👰": [100, 1140, 978],
	"🏽": [40, 5420, 758],
	"🛀": [60, 2460, 1563],
	"😐": [0, 100, 1375],
	"😑": [20, 100, 1376],
	"😒": [40, 100, 1377],
	"🖖": [60, 700, 1328],
	"🚶": [100, 1160, 1548],
	"🙄": [60, 100, 1427],
	"🤔": [80, 100, 1595],
	"✌️": [60, 420, 156],
	"🏼": [20, 5420, 757],
	"😳": [100, 100, 1410],
	"🏃": [100, 1180, 678],
	"🏋": [60, 2500, 706],
	"😞": [0, 120, 1389],
	"😟": [20, 120, 1390],
	"😠": [40, 120, 1391],
	"😡": [60, 120, 1392],
	"😔": [80, 120, 1379],
	"🚴": [60, 2520, 1536],
	"💃": [100, 1200, 1057],
	"😕": [100, 120, 1380],
	"💅": [60, 740, 1064],
	"🙁": [0, 140, 1424],
	"☹️": [20, 140, 77],
	"🚵": [60, 2540, 1542],
	"🏾": [60, 5420, 759],
	"👯": [100, 1220, 977],
	"👫": [0, 1240, 968],
	"👬": [20, 1240, 969],
	"👭": [40, 1240, 970],
	"🏇": [60, 2560, 692],
	"🙇": [60, 1240, 1440],
	"😣": [40, 140, 1394],
	"👌": [60, 440, 878],
	"👄": [60, 760, 840],
	"👅": [80, 760, 841],
	"🕴": [60, 2580, 1305],
	"🏆": [80, 2580, 691],
	"🎽": [100, 2580, 672],
	"🏅": [0, 2600, 690],
	"🎖": [20, 2600, 636],
	"🎗": [40, 2600, 637],
	"🏵": [60, 2600, 751],
	"🎫": [80, 2600, 654],
	"🎟": [100, 2600, 642],
	"🎭": [0, 2620, 656],
	"🎨": [20, 2620, 651],
	"🎪": [40, 2620, 653],
	"🎤": [60, 2620, 647],
	"🎧": [80, 2620, 650],
	"🎼": [100, 2620, 671],
	"🎹": [0, 2640, 668],
	"🎷": [20, 2640, 666],
	"🎺": [40, 2640, 669],
	"🎸": [60, 2640, 667],
	"🎻": [80, 2640, 670],
	"🎬": [100, 2640, 655],
	"🎮": [0, 2660, 657],
	"👾": [20, 2660, 1042],
	"🎯": [40, 2660, 658],
	"🎲": [60, 2660, 661],
	"🎰": [80, 2660, 659],
	"🎳": [100, 2660, 662],
	"🚗": [0, 2680, 1502],
	"🚕": [20, 2680, 1500],
	"🚙": [40, 2680, 1504],
	"🚌": [60, 2680, 1491],
	"🚎": [80, 2680, 1493],
	"🏎": [100, 2680, 714],
	"🚓": [0, 2700, 1498],
	"🚑": [20, 2700, 1496],
	"🚒": [40, 2700, 1497],
	"🚐": [60, 2700, 1495],
	"🚚": [80, 2700, 1505],
	"🚛": [100, 2700, 1506],
	"🚜": [0, 2720, 1507],
	"🏍": [20, 2720, 713],
	"🚲": [40, 2720, 1534],
	"🚨": [60, 2720, 1524],
	"🚔": [80, 2720, 1499],
	"🚍": [100, 2720, 1492],
	"🚘": [0, 2740, 1503],
	"🚖": [20, 2740, 1501],
	"🚡": [40, 2740, 1512],
	"🚠": [60, 2740, 1511],
	"🚟": [80, 2740, 1510],
	"🚃": [100, 2740, 1482],
	"🚋": [0, 2760, 1490],
	"🚝": [20, 2760, 1508],
	"🚄": [40, 2760, 1483],
	"🚅": [60, 2760, 1484],
	"🚈": [80, 2760, 1487],
	"🚞": [100, 2760, 1509],
	"🚂": [0, 2780, 1481],
	"🚆": [20, 2780, 1485],
	"🚇": [40, 2780, 1486],
	"🚊": [60, 2780, 1489],
	"🚉": [80, 2780, 1488],
	"🚁": [100, 2780, 1480],
	"🛩": [0, 2800, 1586],
	"✈️": [20, 2800, 142],
	"👂": [100, 760, 828],
	"🛫": [40, 2800, 1587],
	"🛬": [60, 2800, 1588],
	"⛵️": [80, 2800, 129],
	"💁": [60, 1260, 1045],
	"🛥": [100, 2800, 1585],
	"🚤": [0, 2820, 1520],
	"😖": [60, 140, 1381],
	"🛳": [40, 2820, 1590],
	"🚀": [60, 2820, 1479],
	"🛰": [80, 2820, 1589],
	"💺": [100, 2820, 1141],
	"⚓️": [0, 2840, 99],
	"😫": [80, 140, 1402],
	"🚧": [20, 2840, 1523],
	"⛽️": [40, 2840, 139],
	"😩": [100, 140, 1400],
	"🚏": [60, 2840, 1494],
	"🚦": [80, 2840, 1521],
	"🚥": [100, 2840, 1522],
	"🏁": [0, 2860, 676],
	"🚢": [20, 2860, 1513],
	"🎡": [40, 2860, 644],
	"🎢": [60, 2860, 645],
	"🎠": [80, 2860, 643],
	"🏗": [100, 2860, 723],
	"🌁": [0, 2880, 486],
	"🗼": [20, 2880, 1355],
	"🏭": [40, 2880, 745],
	"⛲️": [60, 2880, 126],
	"😤": [0, 160, 1395],
	"🎑": [80, 2880, 633],
	"😮": [20, 160, 1405],
	"🏔": [0, 2900, 720],
	"🗻": [20, 2900, 1354],
	"🌋": [40, 2900, 496],
	"🗾": [60, 2900, 1357],
	"🏕": [80, 2900, 721],
	"⛺️": [100, 2900, 138],
	"😬": [20, 0, 1403],
	"🏞": [0, 2920, 730],
	"🛣": [20, 2920, 1583],
	"🛤": [40, 2920, 1584],
	"🌅": [60, 2920, 490],
	"🌄": [80, 2920, 489],
	"🏜": [100, 2920, 728],
	"🏖": [0, 2940, 722],
	"🏝": [20, 2940, 729],
	"🌇": [40, 2940, 492],
	"🌆": [60, 2940, 491],
	"🏙": [80, 2940, 725],
	"🌃": [100, 2940, 488],
	"🌉": [0, 2960, 494],
	"🌌": [20, 2960, 497],
	"🌠": [40, 2960, 517],
	"🎇": [60, 2960, 623],
	"🎆": [80, 2960, 622],
	"🌈": [100, 2960, 493],
	"🏘": [0, 2980, 724],
	"🏰": [20, 2980, 748],
	"🏯": [40, 2980, 747],
	"🏟": [60, 2980, 731],
	"🗽": [80, 2980, 1356],
	"🏠": [100, 2980, 732],
	"🏡": [0, 3000, 733],
	"🏚": [20, 3000, 726],
	"🏢": [40, 3000, 734],
	"🏬": [60, 3000, 744],
	"🏣": [80, 3000, 735],
	"🏤": [100, 3000, 736],
	"🏥": [0, 3020, 737],
	"🏦": [20, 3020, 738],
	"🏨": [40, 3020, 740],
	"🏪": [60, 3020, 742],
	"🏫": [80, 3020, 743],
	"🏩": [100, 3020, 741],
	"💒": [0, 3040, 1096],
	"🏛": [20, 3040, 727],
	"⛪️": [40, 3040, 123],
	"👃": [100, 780, 834],
	"🕌": [60, 3040, 1275],
	"🕍": [80, 3040, 1276],
	"🕋": [100, 3040, 1274],
	"😱": [40, 160, 1408],
	"⌚️": [0, 3080, 27],
	"😨": [60, 160, 1399],
	"📱": [20, 3080, 1196],
	"📲": [40, 3080, 1197],
	"💻": [60, 3080, 1142],
	"😰": [80, 160, 1407],
	"🖥": [100, 3080, 1334],
	"🖨": [0, 3100, 1335],
	"🖱": [20, 3100, 1336],
	"🖲": [40, 3100, 1337],
	"🕹": [60, 3100, 1310],
	"🗜": [80, 3100, 1345],
	"💽": [100, 3100, 1144],
	"💾": [0, 3120, 1145],
	"💿": [20, 3120, 1146],
	"📀": [40, 3120, 1147],
	"📼": [60, 3120, 1207],
	"📷": [80, 3120, 1202],
	"📸": [100, 3120, 1203],
	"📹": [0, 3140, 1204],
	"🎥": [20, 3140, 648],
	"📽": [40, 3140, 1208],
	"🎞": [60, 3140, 641],
	"📞": [80, 3140, 1177],
	"☎️": [100, 3140, 58],
	"😯": [100, 160, 1406],
	"📟": [0, 3160, 1178],
	"📠": [20, 3160, 1179],
	"📺": [40, 3160, 1205],
	"📻": [60, 3160, 1206],
	"🎙": [80, 3160, 638],
	"🎚": [100, 3160, 639],
	"🎛": [0, 3180, 640],
	"🙆": [60, 1300, 1434],
	"😦": [0, 180, 1397],
	"👁": [100, 800, 826],
	"🕰": [80, 3180, 1303],
	"👀": [0, 820, 825],
	"⌛️": [0, 3200, 28],
	"👤": [20, 820, 927],
	"📡": [20, 3200, 1180],
	"🔋": [40, 3200, 1221],
	"🔌": [60, 3200, 1222],
	"💡": [80, 3200, 1111],
	"🔦": [100, 3200, 1248],
	"🕯": [0, 3220, 1302],
	"🗑": [20, 3220, 1342],
	"🛢": [40, 3220, 1582],
	"💸": [60, 3220, 1139],
	"💵": [80, 3220, 1136],
	"💴": [100, 3220, 1135],
	"💶": [0, 3240, 1137],
	"💷": [20, 3240, 1138],
	"💰": [40, 3240, 1131],
	"💳": [60, 3240, 1134],
	"💎": [80, 3240, 1088],
	"👥": [40, 820, 928],
	"🔧": [0, 3260, 1249],
	"🔨": [20, 3260, 1250],
	"🙋": [60, 1320, 1449],
	"🛠": [60, 3260, 1580],
	"🗣": [60, 820, 1349],
	"🔩": [100, 3260, 1251],
	"👶": [80, 820, 1014],
	"🏻": [0, 5420, 756],
	"🔫": [40, 3280, 1253],
	"💣": [60, 3280, 1113],
	"🔪": [80, 3280, 1252],
	"🗡": [100, 3280, 1348],
	"😧": [20, 180, 1398],
	"🛡": [20, 3300, 1581],
	"🚬": [40, 3300, 1528],
	"😢": [40, 180, 1393],
	"🙎": [60, 1340, 1467],
	"😥": [60, 180, 1396],
	"🏺": [0, 3320, 755],
	"🔮": [20, 3320, 1256],
	"📿": [40, 3320, 1209],
	"💈": [60, 3320, 1082],
	"😪": [80, 180, 1401],
	"🔭": [100, 3320, 1255],
	"🔬": [0, 3340, 1254],
	"🕳": [20, 3340, 1304],
	"💊": [40, 3340, 1084],
	"💉": [60, 3340, 1083],
	"🌡": [80, 3340, 518],
	"🏷": [100, 3340, 752],
	"🔖": [0, 3360, 1232],
	"🚽": [20, 3360, 1560],
	"🚿": [40, 3360, 1562],
	"🛁": [60, 3360, 1569],
	"🔑": [80, 3360, 1227],
	"🗝": [100, 3360, 1346],
	"🛋": [0, 3380, 1574],
	"🛌": [20, 3380, 1575],
	"🛏": [40, 3380, 1578],
	"🚪": [60, 3380, 1526],
	"🛎": [80, 3380, 1577],
	"🖼": [100, 3380, 1338],
	"🗺": [0, 3400, 1353],
	"👦": [80, 840, 929],
	"🗿": [40, 3400, 1358],
	"🛍": [60, 3400, 1576],
	"🎈": [80, 3400, 624],
	"🎏": [100, 3400, 631],
	"🎀": [0, 3420, 611],
	"🎁": [20, 3420, 612],
	"🎊": [40, 3420, 626],
	"🎉": [60, 3420, 625],
	"🎎": [80, 3420, 630],
	"🎐": [100, 3420, 632],
	"🎌": [0, 3440, 628],
	"🏮": [20, 3440, 746],
	"✉️": [40, 3440, 143],
	"😓": [100, 180, 1378],
	"📩": [60, 3440, 1188],
	"📨": [80, 3440, 1187],
	"📧": [100, 3440, 1186],
	"💌": [0, 3460, 1086],
	"📮": [20, 3460, 1193],
	"📪": [40, 3460, 1189],
	"📫": [60, 3460, 1190],
	"📬": [80, 3460, 1191],
	"📭": [100, 3460, 1192],
	"📦": [0, 3480, 1185],
	"📯": [20, 3480, 1194],
	"📥": [40, 3480, 1184],
	"📤": [60, 3480, 1183],
	"📜": [80, 3480, 1175],
	"📃": [100, 3480, 1150],
	"📑": [0, 3500, 1164],
	"📊": [20, 3500, 1157],
	"📈": [40, 3500, 1155],
	"📉": [60, 3500, 1156],
	"📄": [80, 3500, 1151],
	"📅": [100, 3500, 1152],
	"📆": [0, 3520, 1153],
	"🗓": [20, 3520, 1344],
	"📇": [40, 3520, 1154],
	"🗃": [60, 3520, 1340],
	"🗳": [80, 3520, 1352],
	"🗄": [100, 3520, 1341],
	"📋": [0, 3540, 1158],
	"🗒": [20, 3540, 1343],
	"📁": [40, 3540, 1148],
	"📂": [60, 3540, 1149],
	"🗂": [80, 3540, 1339],
	"🗞": [100, 3540, 1347],
	"📰": [0, 3560, 1195],
	"📓": [20, 3560, 1166],
	"📕": [40, 3560, 1168],
	"📗": [60, 3560, 1170],
	"📘": [80, 3560, 1171],
	"📙": [100, 3560, 1172],
	"📔": [0, 3580, 1167],
	"📒": [20, 3580, 1165],
	"📚": [40, 3580, 1173],
	"📖": [60, 3580, 1169],
	"🔗": [80, 3580, 1233],
	"📎": [100, 3580, 1161],
	"🖇": [0, 3600, 1311],
	"✂️": [20, 3600, 140],
	"👐": [60, 480, 902],
	"📐": [40, 3600, 1163],
	"📏": [60, 3600, 1162],
	"📌": [80, 3600, 1159],
	"📍": [100, 3600, 1160],
	"🚩": [0, 3620, 1525],
	"🏳": [20, 3620, 749],
	"🏴": [40, 3620, 750],
	"🔐": [60, 3620, 1226],
	"🔒": [80, 3620, 1228],
	"🔓": [100, 3620, 1229],
	"🔏": [0, 3640, 1225],
	"🖊": [20, 3640, 1312],
	"🖋": [40, 3640, 1313],
	"✒️": [60, 3640, 169],
	"🙍": [60, 1360, 1461],
	"📝": [80, 3640, 1176],
	"✏️": [100, 3640, 168],
	"😭": [0, 200, 1404],
	"🖍": [0, 3660, 1315],
	"🖌": [20, 3660, 1314],
	"🔍": [40, 3660, 1223],
	"🔎": [60, 3660, 1224],
	"❤️": [0, 3680, 186],
	"😵": [20, 200, 1409],
	"💛": [20, 3680, 1105],
	"💚": [40, 3680, 1104],
	"💙": [60, 3680, 1103],
	"💜": [80, 3680, 1106],
	"💔": [100, 3680, 1098],
	"❣️": [0, 3700, 185],
	"😲": [40, 200, 1412],
	"💕": [20, 3700, 1099],
	"💞": [40, 3700, 1108],
	"💓": [60, 3700, 1097],
	"💗": [80, 3700, 1101],
	"💖": [100, 3700, 1100],
	"💘": [0, 3720, 1102],
	"💝": [20, 3720, 1107],
	"💟": [40, 3720, 1109],
	"👧": [80, 860, 935],
	"✝️": [80, 3720, 172],
	"🤐": [60, 200, 1591],
	"💇": [60, 1380, 1076],
	"🕉": [0, 3740, 1272],
	"😷": [80, 200, 1414],
	"✡️": [40, 3740, 173],
	"💪": [60, 500, 1120],
	"🔯": [60, 3740, 1257],
	"🕎": [80, 3740, 1277],
	"☯️": [100, 3740, 75],
	"🤒": [100, 200, 1593],
	"🤕": [0, 220, 1596],
	"🛐": [20, 3760, 1579],
	"👨": [80, 880, 941],
	"♈️": [60, 3760, 79],
	"💆": [60, 1400, 1070],
	"♉️": [80, 3760, 80],
	"😴": [20, 220, 1411],
	"♊️": [100, 3760, 81],
	"💤": [40, 220, 1114],
	"♋️": [0, 3780, 82],
	"💩": [60, 220, 1119],
	"♌️": [20, 3780, 83],
	"🙏": [60, 520, 1473],
	"♍️": [40, 3780, 84],
	"😈": [80, 220, 1367],
	"♎️": [60, 3780, 85],
	"💑": [60, 1420, 1093],
	"♏️": [80, 3780, 86],
	"👩": [80, 900, 947],
	"♐️": [100, 3780, 87],
	"👿": [100, 220, 1043],
	"♑️": [0, 3800, 88],
	"👹": [0, 240, 1032],
	"♒️": [20, 3800, 89],
	"👺": [20, 240, 1033],
	"♓️": [40, 3800, 90],
	"💏": [0, 1440, 1089],
	"🆔": [60, 3800, 216],
	"💀": [40, 240, 1044],
	"🈳": [100, 3800, 475],
	"🈹": [0, 3820, 481],
	"☝️": [60, 540, 63],
	"👱": [80, 920, 984],
	"📴": [60, 3820, 1199],
	"📳": [80, 3820, 1198],
	"🈶": [100, 3820, 478],
	"👻": [60, 240, 1034],
	"🈚": [0, 3840, 472],
	"👪": [60, 1440, 953],
	"🈸": [20, 3840, 480],
	"🈺": [40, 3840, 482],
	"👽": [80, 240, 1041],
	"🈷": [60, 3840, 479],
	"✴️": [80, 3840, 176],
	"🤖": [100, 240, 1597],
	"🆚": [100, 3840, 222],
	"🉑": [0, 3860, 484],
	"💮": [20, 3860, 1129],
	"🉐": [40, 3860, 483],
	"㊙️": [60, 3860, 205],
	"😺": [0, 260, 1417],
	"㊗️": [80, 3860, 204],
	"😸": [20, 260, 1415],
	"🈴": [100, 3860, 476],
	"🈵": [0, 3880, 477],
	"🈲": [20, 3880, 474],
	"👴": [80, 940, 1002],
	"🅰": [40, 3880, 208],
	"😹": [40, 260, 1416],
	"🅱": [60, 3880, 209],
	"🆎": [80, 3880, 212],
	"🆑": [100, 3880, 213],
	"😻": [60, 260, 1418],
	"🅾": [0, 3900, 210],
	"🆘": [20, 3900, 220],
	"⛔️": [40, 3900, 121],
	"😼": [80, 260, 1419],
	"📛": [60, 3900, 1174],
	"🚫": [80, 3900, 1527],
	"😽": [100, 260, 1420],
	"⭕️": [0, 3920, 201],
	"🙀": [0, 280, 1423],
	"💢": [20, 3920, 1112],
	"♨️": [40, 3920, 95],
	"👵": [80, 960, 1008],
	"🚷": [60, 3920, 1554],
	"🚯": [80, 3920, 1531],
	"🚳": [100, 3920, 1535],
	"🚱": [0, 3940, 1533],
	"🔞": [20, 3940, 1240],
	"📵": [40, 3940, 1200],
	"❗️": [60, 3940, 184],
	"😿": [20, 280, 1422],
	"😾": [40, 280, 1421],
	"👆": [60, 560, 842],
	"🙌": [60, 280, 1455],
	"‼️": [20, 3960, 15],
	"😀": [0, 0, 1359],
	"⁉️": [40, 3960, 16],
	"👲": [80, 980, 990],
	"💯": [60, 3960, 1130],
	"🔅": [80, 3960, 1215],
	"🔆": [100, 3960, 1216],
	"🔱": [0, 3980, 1259],
	"😁": [40, 0, 1360],
	"〽️": [40, 3980, 203],
	"😂": [60, 0, 1361],
	"⚠️": [60, 3980, 106],
	"😃": [80, 0, 1362],
	"🚸": [80, 3980, 1555],
	"🔰": [100, 3980, 1258],
	"♻️": [0, 4000, 96],
	"😄": [100, 0, 1363],
	"👏": [60, 300, 896],
	"🈯": [20, 4000, 473],
	"👳": [80, 1000, 996],
	"💹": [40, 4000, 1140],
	"❇️": [60, 4000, 178],
	"😅": [0, 20, 1364],
	"✳️": [80, 4000, 175],
	"😆": [20, 20, 1365],
	"😇": [40, 20, 1366],
	"👇": [60, 580, 848],
	"💠": [20, 4020, 1110],
	"🌀": [40, 4020, 485],
	"😉": [60, 20, 1368],
	"🌐": [80, 4020, 501],
	"Ⓜ️": [100, 4020, 44],
	"👚": [0, 1500, 917],
	"🏧": [0, 4040, 739],
	"👕": [20, 1500, 912],
	"🈂": [20, 4040, 471],
	"🛂": [40, 4040, 1570],
	"🛃": [60, 4040, 1571],
	"🛄": [80, 4040, 1572],
	"🛅": [100, 4040, 1573],
	"♿️": [0, 4060, 97],
	"👖": [40, 1500, 913],
	"🚭": [20, 4060, 1529],
	"🚾": [40, 4060, 1561],
	"👔": [60, 1500, 911],
	"🅿": [60, 4060, 211],
	"👗": [80, 1500, 914],
	"🚰": [80, 4060, 1532],
	"🚹": [100, 4060, 1556],
	"🚺": [0, 4080, 1557],
	"🚼": [20, 4080, 1559],
	"🚻": [40, 4080, 1558],
	"🚮": [60, 4080, 1530],
	"🎦": [80, 4080, 649],
	"📶": [100, 4080, 1201],
	"🈁": [0, 4100, 470],
	"🆖": [20, 4100, 218],
	"🆗": [40, 4100, 219],
	"🆙": [60, 4100, 221],
	"🆒": [80, 4100, 214],
	"🆕": [100, 4100, 217],
	"🆓": [0, 4120, 215],
	"👙": [100, 1500, 916],
	"0⃣": [20, 4120, 3],
	"👘": [0, 1520, 915],
	"1⃣": [40, 4120, 4],
	"💄": [20, 1520, 1063],
	"2⃣": [60, 4120, 5],
	"💋": [40, 1520, 1085],
	"3⃣": [80, 4120, 6],
	"👣": [60, 1520, 926],
	"4⃣": [100, 4120, 7],
	"👠": [80, 1520, 923],
	"5⃣": [0, 4140, 8],
	"👡": [100, 1520, 924],
	"6⃣": [20, 4140, 9],
	"👢": [0, 1540, 925],
	"7⃣": [40, 4140, 10],
	"👞": [20, 1540, 921],
	"8⃣": [60, 4140, 11],
	"👟": [40, 1540, 922],
	"9⃣": [80, 4140, 12],
	"🔟": [100, 4140, 1241],
	"🔢": [0, 4160, 1244],
	"▶️": [20, 4160, 47],
	"👒": [60, 1540, 909],
	"🎩": [80, 1540, 652],
	"🎓": [100, 1540, 635],
	"👑": [0, 1560, 908],
	"👮": [80, 1020, 971],
	"🎒": [40, 1560, 634],
	"👝": [60, 1560, 920],
	"👛": [80, 1560, 918],
	"👜": [100, 1560, 919],
	"🔀": [80, 4180, 1210],
	"🔁": [100, 4180, 1211],
	"🔂": [0, 4200, 1212],
	"◀️": [20, 4200, 48],
	"💼": [0, 1580, 1143],
	"🔼": [40, 4200, 1270],
	"🔽": [60, 4200, 1271],
	"👓": [20, 1580, 910],
	"🕶": [40, 1580, 1307],
	"➡️": [0, 4220, 190],
	"💍": [60, 1580, 1087],
	"⬅️": [20, 4220, 195],
	"🌂": [80, 1580, 487],
	"⬆️": [40, 4220, 196],
	"🐶": [0, 1600, 815],
	"⬇️": [60, 4220, 197],
	"🐱": [20, 1600, 810],
	"↗️": [80, 4220, 22],
	"🐭": [40, 1600, 806],
	"↘️": [100, 4220, 23],
	"🐹": [60, 1600, 818],
	"↙️": [0, 4240, 24],
	"🐰": [80, 1600, 809],
	"↖️": [20, 4240, 21],
	"🐻": [100, 1600, 820],
	"↕️": [40, 4240, 20],
	"🐼": [0, 1620, 821],
	"↔️": [60, 4240, 19],
	"🐨": [20, 1620, 801],
	"🔄": [80, 4240, 1214],
	"↪️": [100, 4240, 26],
	"🐯": [40, 1620, 808],
	"↩️": [0, 4260, 25],
	"🦁": [60, 1620, 1606],
	"⤴️": [20, 4260, 193],
	"🐮": [80, 1620, 807],
	"⤵️": [40, 4260, 194],
	"🐷": [100, 1620, 816],
	"🐽": [0, 1640, 822],
	"#⃣": [60, 4260, 1],
	"🐸": [20, 1640, 817],
	"*⃣": [80, 4260, 2],
	"ℹ️": [100, 4260, 18],
	"🐙": [40, 1640, 786],
	"🔤": [0, 4280, 1246],
	"🔡": [20, 4280, 1243],
	"🔠": [40, 4280, 1242],
	"🔣": [60, 4280, 1245],
	"🎵": [80, 4280, 664],
	"🎶": [100, 4280, 665],
	"〰️": [0, 4300, 202],
	"🐵": [60, 1640, 814],
	"🙈": [80, 1640, 1446],
	"✔️": [40, 4300, 170],
	"🙉": [100, 1640, 1447],
	"🔃": [60, 4300, 1213],
	"🙊": [0, 1660, 1448],
	"🐒": [20, 1660, 779],
	"🐔": [40, 1660, 781],
	"✖️": [20, 4320, 171],
	"🐧": [60, 1660, 800],
	"💲": [40, 4320, 1133],
	"💱": [60, 4320, 1132],
	"©️": [80, 4320, 13],
	"🐦": [80, 1660, 799],
	"®️": [100, 4320, 14],
	"🐤": [100, 1660, 797],
	"™️": [0, 4340, 17],
	"🐣": [0, 1680, 796],
	"🔚": [20, 4340, 1236],
	"🔙": [40, 4340, 1235],
	"🔛": [60, 4340, 1237],
	"🔝": [80, 4340, 1239],
	"🔜": [100, 4340, 1238],
	"☑️": [0, 4360, 59],
	"🐥": [20, 1680, 798],
	"🔘": [20, 4360, 1234],
	"⚪️": [40, 4360, 108],
	"🐺": [40, 1680, 819],
	"⚫️": [60, 4360, 109],
	"🐗": [60, 1680, 784],
	"🔴": [80, 4360, 1262],
	"🔵": [100, 4360, 1263],
	"🔸": [0, 4380, 1266],
	"🔹": [20, 4380, 1267],
	"🔶": [40, 4380, 1264],
	"🔷": [60, 4380, 1265],
	"🔺": [80, 4380, 1268],
	"▪️": [100, 4380, 45],
	"🐴": [80, 1680, 813],
	"▫️": [0, 4400, 46],
	"🦄": [100, 1680, 1609],
	"⬛️": [20, 4400, 198],
	"🐝": [0, 1700, 790],
	"⬜️": [40, 4400, 199],
	"🐛": [20, 1700, 788],
	"🔻": [60, 4400, 1269],
	"◼️": [80, 4400, 50],
	"🐌": [40, 1700, 773],
	"◻️": [100, 4400, 49],
	"🐞": [60, 1700, 791],
	"◾️": [0, 4420, 52],
	"🐜": [80, 1700, 789],
	"◽️": [20, 4420, 51],
	"🕷": [100, 1700, 1308],
	"🔲": [40, 4420, 1260],
	"🔳": [60, 4420, 1261],
	"🔈": [80, 4420, 1218],
	"🔉": [100, 4420, 1219],
	"🔊": [0, 4440, 1220],
	"🔇": [20, 4440, 1217],
	"📣": [40, 4440, 1182],
	"📢": [60, 4440, 1181],
	"🔔": [80, 4440, 1230],
	"🔕": [100, 4440, 1231],
	"🃏": [0, 4460, 207],
	"🦂": [0, 1720, 1607],
	"🀄": [20, 4460, 206],
	"🦀": [20, 1720, 1605],
	"♠️": [40, 4460, 91],
	"🐍": [40, 1720, 774],
	"♣️": [60, 4460, 92],
	"🐢": [60, 1720, 795],
	"♥️": [80, 4460, 93],
	"🐠": [80, 1720, 793],
	"♦️": [100, 4460, 94],
	"🐟": [100, 1720, 792],
	"🎴": [0, 4480, 663],
	"🐡": [0, 1740, 794],
	"🐬": [20, 1740, 805],
	"💭": [40, 4480, 1128],
	"🗯": [60, 4480, 1351],
	"💬": [80, 4480, 1127],
	"🕐": [100, 4480, 1278],
	"🕑": [0, 4500, 1279],
	"🕒": [20, 4500, 1280],
	"🕓": [40, 4500, 1281],
	"🕔": [60, 4500, 1282],
	"🕕": [80, 4500, 1283],
	"🕖": [100, 4500, 1284],
	"🕗": [0, 4520, 1285],
	"🕘": [20, 4520, 1286],
	"🕙": [40, 4520, 1287],
	"🕚": [60, 4520, 1288],
	"🕛": [80, 4520, 1289],
	"🕜": [100, 4520, 1290],
	"🕝": [0, 4540, 1291],
	"🕞": [20, 4540, 1292],
	"🕟": [40, 4540, 1293],
	"🕠": [60, 4540, 1294],
	"🕡": [80, 4540, 1295],
	"🕢": [100, 4540, 1296],
	"🕣": [0, 4560, 1297],
	"🕤": [20, 4560, 1298],
	"🕥": [40, 4560, 1299],
	"🕦": [60, 4560, 1300],
	"🕧": [80, 4560, 1301],
	"🐳": [40, 1740, 812],
	"🐋": [60, 1740, 772],
	"🐊": [80, 1740, 771],
	"🐆": [100, 1740, 767],
	"🐅": [0, 1760, 766],
	"🐃": [20, 1760, 764],
	"🐂": [40, 1760, 763],
	"🐄": [60, 1760, 765],
	"🐪": [80, 1760, 803],
	"🐫": [100, 1760, 804],
	"🐘": [0, 1780, 785],
	"🐐": [20, 1780, 777],
	"🐏": [40, 1780, 776],
	"🐑": [60, 1780, 778],
	"🐎": [80, 1780, 775],
	"🐖": [100, 1780, 783],
	"🐀": [0, 1800, 761],
	"🐁": [20, 1800, 762],
	"🐓": [40, 1800, 780],
	"🦃": [60, 1800, 1608],
	"🕊": [80, 1800, 1273],
	"🐕": [100, 1800, 782],
	"🐩": [0, 1820, 802],
	"🐈": [20, 1820, 769],
	"🐇": [40, 1820, 768],
	"🐿": [60, 1820, 824],
	"🐾": [80, 1820, 823],
	"🐉": [100, 1820, 770],
	"🐲": [0, 1840, 811],
	"🌵": [20, 1840, 536],
	"🎄": [40, 1840, 615],
	"🌲": [60, 1840, 533],
	"🌳": [80, 1840, 534],
	"🌴": [100, 1840, 535],
	"🌱": [0, 1860, 532],
	"🌿": [20, 1860, 546],
	"😊": [80, 20, 1369],
	"🍀": [60, 1860, 547],
	"🎍": [80, 1860, 629],
	"🎋": [100, 1860, 627],
	"🍃": [0, 1880, 550],
	"🍂": [20, 1880, 549],
	"🍁": [40, 1880, 548],
	"🌾": [60, 1880, 545],
	"🌺": [80, 1880, 541],
	"🌻": [100, 1880, 542],
	"🌹": [0, 1900, 540],
	"🌷": [20, 1900, 538],
	"🌼": [40, 1900, 543],
	"🌸": [60, 1900, 539],
	"💐": [80, 1900, 1092],
	"🍄": [100, 1900, 551],
	"🌰": [0, 1920, 531],
	"🎃": [20, 1920, 614],
	"🐚": [40, 1920, 787],
	"🕸": [60, 1920, 1309],
	"🌎": [80, 1920, 499],
	"🌍": [100, 1920, 498],
	"🌏": [0, 1940, 500],
	"🌕": [20, 1940, 506],
	"🌖": [40, 1940, 507],
	"🌗": [60, 1940, 508],
	"🌘": [80, 1940, 509],
	"🌑": [100, 1940, 502],
	"🌒": [0, 1960, 503],
	"🌓": [20, 1960, 504],
	"🌔": [40, 1960, 505],
	"🌚": [60, 1960, 511],
	"🌝": [80, 1960, 514],
	"🌛": [100, 1960, 512],
	"🌜": [0, 1980, 513],
	"🌞": [20, 1980, 515],
	"🌙": [40, 1980, 510],
	"⭐️": [60, 1980, 200],
	"👋": [60, 320, 872],
	"🙂": [100, 20, 1425],
	"🌟": [80, 1980, 516],
	"💫": [100, 1980, 1126],
	"🙃": [0, 40, 1426],
	"👈": [60, 600, 854],
	"☀️": [40, 2000, 53],
	"👷": [80, 1040, 1020],
	"☺️": [20, 40, 78],
	"🌤": [60, 2000, 519],
	"⛅️": [80, 2000, 115],
	"🏿": [80, 5420, 760],
	"😋": [40, 40, 1370],
	"🌥": [100, 2000, 520],
	"🌦": [0, 2020, 521],
	"🗨": [100, 5420, 1350],
	"♦": [100, 4460, 94],
	"♣": [60, 4460, 92],
	"♠": [40, 4460, 91],
	"◽": [20, 4420, 51],
	"◾": [0, 4420, 52],
	"◻": [100, 4400, 49],
	"◼": [80, 4400, 50],
	"⬜": [40, 4400, 199],
	"⬛": [20, 4400, 198],
	"▫": [0, 4400, 46],
	"▪": [100, 4380, 45],
	"⚫": [60, 4360, 109],
	"⚪": [40, 4360, 108],
	"☑": [0, 4360, 59],
	"™": [0, 4340, 17],
	"®": [100, 4320, 14],
	"©": [80, 4320, 13],
	"✖": [20, 4320, 171],
	"➗": [0, 4320, 189],
	"➖": [100, 4300, 188],
	"➕": [80, 4300, 187],
	"✔": [40, 4300, 170],
	"➰": [20, 4300, 191],
	"〰": [0, 4300, 202],
	"ℹ": [100, 4260, 18],
	"⤵": [40, 4260, 194],
	"⤴": [20, 4260, 193],
	"↩": [0, 4260, 25],
	"↪": [100, 4240, 26],
	"↔": [60, 4240, 19],
	"↕": [40, 4240, 20],
	"↖": [20, 4240, 21],
	"↙": [0, 4240, 24],
	"↘": [100, 4220, 23],
	"↗": [80, 4220, 22],
	"⬇": [60, 4220, 197],
	"⬆": [40, 4220, 196],
	"⬅": [20, 4220, 195],
	"➡": [0, 4220, 190],
	"⏬": [100, 4200, 33],
	"⏫": [80, 4200, 32],
	"◀": [20, 4200, 48],
	"⏪": [60, 4180, 31],
	"⏩": [40, 4180, 30],
	"⏮": [20, 4180, 35],
	"⏭": [0, 4180, 34],
	"⏺": [100, 4160, 43],
	"⏹": [80, 4160, 42],
	"⏯": [60, 4160, 36],
	"⏸": [40, 4160, 41],
	"▶": [20, 4160, 47],
	"♿": [0, 4060, 97],
	"Ⓜ": [100, 4020, 44],
	"➿": [60, 4020, 192],
	"✅": [0, 4020, 141],
	"❎": [100, 4000, 180],
	"✳": [80, 4000, 175],
	"❇": [60, 4000, 178],
	"♻": [0, 4000, 96],
	"⚠": [60, 3980, 106],
	"〽": [40, 3980, 203],
	"⚜": [20, 3980, 105],
	"⁉": [40, 3960, 16],
	"‼": [20, 3960, 15],
	"❔": [0, 3960, 182],
	"❓": [100, 3940, 181],
	"❕": [80, 3940, 183],
	"❗": [60, 3940, 184],
	"♨": [40, 3920, 95],
	"⭕": [0, 3920, 201],
	"❌": [100, 3900, 179],
	"⛔": [40, 3900, 121],
	"㊗": [80, 3860, 204],
	"㊙": [60, 3860, 205],
	"✴": [80, 3840, 176],
	"☣": [40, 3820, 71],
	"☢": [20, 3820, 70],
	"⚛": [80, 3800, 104],
	"♓": [40, 3800, 90],
	"♒": [20, 3800, 89],
	"♑": [0, 3800, 88],
	"♥": [80, 4460, 93],
	"♏": [80, 3780, 86],
	"♎": [60, 3780, 85],
	"♍": [40, 3780, 84],
	"♌": [20, 3780, 83],
	"♋": [0, 3780, 82],
	"♊": [100, 3760, 81],
	"♉": [80, 3760, 80],
	"♈": [60, 3760, 79],
	"⛎": [40, 3760, 117],
	"☦": [0, 3760, 72],
	"☯": [100, 3740, 75],
	"✡": [40, 3740, 173],
	"☸": [20, 3740, 76],
	"☪": [100, 3720, 73],
	"✝": [80, 3720, 172],
	"☮": [60, 3720, 74],
	"❣": [0, 3700, 185],
	"❤": [0, 3680, 186],
	"✏": [100, 3640, 168],
	"✒": [60, 3640, 169],
	"✂": [20, 3600, 140],
	"✉": [40, 3440, 143],
	"⛱": [20, 3400, 125],
	"⚗": [80, 3320, 102],
	"⚱": [100, 3300, 111],
	"⚰": [80, 3300, 110],
	"☠": [60, 3300, 69],
	"⚔": [0, 3300, 100],
	"⛓": [20, 3280, 120],
	"⚙": [0, 3280, 103],
	"⛏": [80, 3260, 118],
	"⚒": [40, 3260, 98],
	"⚖": [100, 3240, 101],
	"⌛": [0, 3200, 28],
	"⏳": [100, 3180, 40],
	"⏰": [60, 3180, 37],
	"⏲": [40, 3180, 39],
	"⏱": [20, 3180, 38],
	"☎": [100, 3140, 58],
	"⌨": [80, 3080, 29],
	"⌚": [0, 3080, 27],
	"⛩": [0, 3060, 122],
	"⛪": [40, 3040, 123],
	"⛺": [100, 2900, 138],
	"⛰": [100, 2880, 124],
	"⛲": [60, 2880, 126],
	"⛽": [40, 2840, 139],
	"⚓": [0, 2840, 99],
	"⛴": [20, 2820, 128],
	"⛵": [80, 2800, 129],
	"✈": [20, 2800, 142],
	"⛹": [60, 2480, 132],
	"⛸": [0, 2400, 131],
	"⛷": [80, 2380, 130],
	"⛳": [40, 2360, 127],
	"⚾": [60, 2340, 113],
	"⚽": [0, 2340, 112],
	"☕": [60, 2300, 61],
	"☔": [100, 2060, 60],
	"☂": [80, 2060, 55],
	"⛄": [100, 2040, 114],
	"☃": [80, 2040, 56],
	"❄": [40, 2040, 177],
	"⚡": [100, 2020, 107],
	"⛈": [60, 2020, 116],
	"☁": [20, 2020, 54],
	"⛅": [80, 2000, 115],
	"☀": [40, 2000, 53],
	"☄": [20, 2000, 57],
	"✨": [0, 2000, 174],
	"⭐": [60, 1980, 200],
	"☘": [40, 1860, 62],
	"⛑": [20, 1560, 119],
	"✍": [60, 720, 162],
	"☝": [60, 540, 63],
	"✋": [60, 460, 150],
	"✌": [60, 420, 156],
	"✊": [60, 400, 144],
	"☹": [20, 140, 77],
	"☺": [20, 40, 78],
	"♐": [100, 3780, 87]
};
